/* eslint-disable */
import { DocumentTypeDecoration } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /**
   * AppSync custom scalar for arbitrary JSON content. At runtime, AppSync
   * coerces this to a JSON string. Used for structured data that doesn't
   * need static typing (e.g. LibertyAI message blocks, variable payloads).
   */
  AWSJSON: { input: any; output: any };
};

export type Address = {
  __typename?: "Address";
  city?: Maybe<Scalars["String"]["output"]>;
  country?: Maybe<Scalars["String"]["output"]>;
  postalCode?: Maybe<Scalars["String"]["output"]>;
  stateProvinceRegion?: Maybe<Scalars["String"]["output"]>;
  street?: Maybe<Scalars["String"]["output"]>;
};

export type AddressChangeResult = {
  __typename?: "AddressChangeResult";
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

/** A state/province picklist entry with its parent country code. */
export type AddressStateOption = {
  __typename?: "AddressStateOption";
  countryCode: Scalars["String"]["output"];
  label: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

/**
 * Application-wide configuration values. Backed by a static None-data-source
 * resolver for now; individual fields can later move to a persistent store
 * without changing the client query shape.
 */
export type AppConfig = {
  __typename?: "AppConfig";
  /** URL of the global onboarding video shown in the app. */
  onboardingVideoUrl?: Maybe<Scalars["String"]["output"]>;
};

export type ApproveObservationResult = {
  __typename?: "ApproveObservationResult";
  issueKey: Scalars["String"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type ApproveObservationsResult = {
  __typename?: "ApproveObservationsResult";
  results: Array<ApproveObservationResult>;
};

export type Attachment = {
  __typename?: "Attachment";
  mimeType: Scalars["String"]["output"];
  style?: Maybe<AttachmentStyle>;
  title: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type AttachmentInput = {
  mimeType: Scalars["String"]["input"];
  style?: InputMaybe<AttachmentStyle>;
  title: Scalars["String"]["input"];
  url: Scalars["String"]["input"];
};

export enum AttachmentStyle {
  Destructive = "DESTRUCTIVE",
  Outline = "OUTLINE",
  Primary = "PRIMARY",
  Secondary = "SECONDARY",
}

/**
 * Upcoming Liberty Fund Board Meeting.
 *
 * Sourced from the "Board Meeting Deadlines" Google Calendar (replaces the
 * former Salesforce `Board_Date__c` field). Only true board meeting events are
 * returned — materials deadlines, package-distribution dates, and other
 * preparatory entries on the same calendar are filtered out by the resolver.
 */
export type BoardMeeting = Node & {
  __typename?: "BoardMeeting";
  /**
   * ISO-8601 date (YYYY-MM-DD) the board meeting ends. For all-day Google
   * Calendar events the raw end date is exclusive; the resolver returns the
   * inclusive last-day value.
   */
  endDate?: Maybe<Scalars["String"]["output"]>;
  /** Google Calendar event id. Stable across fetches for the same occurrence. */
  id: Scalars["ID"]["output"];
  /**
   * ISO-8601 date (YYYY-MM-DD) the board meeting starts. All-day events are
   * the norm on this calendar.
   */
  startDate: Scalars["String"]["output"];
  /** Event summary, e.g. `Liberty Fund Board Meeting`. */
  title: Scalars["String"]["output"];
};

export type ConfereeNoteInput = {
  guid: Scalars["String"]["input"];
  notes: Scalars["String"]["input"];
};

export type ConfereePaymentStatusInput = {
  guid: Scalars["String"]["input"];
  paymentStatuses: Array<RolePaymentStatusInput>;
};

export type ConferenceInterest = {
  __typename?: "ConferenceInterest";
  eNumber: Scalars["String"]["output"];
  /** CampaignMember Id backing the watchlist entry. */
  id: Scalars["ID"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
};

export type ConversationMessage = {
  __typename?: "ConversationMessage";
  attachments?: Maybe<Array<Attachment>>;
  body: Scalars["String"]["output"];
  conversationId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  senderAvatar?: Maybe<Scalars["String"]["output"]>;
  senderId: Scalars["String"]["output"];
  senderName: Scalars["String"]["output"];
  timestamp: Scalars["String"]["output"];
};

export type ConversationMessageConnection = {
  __typename?: "ConversationMessageConnection";
  items: Array<ConversationMessage>;
  nextToken?: Maybe<Scalars["String"]["output"]>;
};

export enum ConversationStatus {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
}

export type CreateConversationInput = {
  conferenceId: Scalars["String"]["input"];
  participantIds: Array<Scalars["String"]["input"]>;
  title?: InputMaybe<Scalars["String"]["input"]>;
};

export type CreateConversationResult = {
  __typename?: "CreateConversationResult";
  conferenceId?: Maybe<Scalars["String"]["output"]>;
  createdAt: Scalars["String"]["output"];
  createdBy: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  status: ConversationStatus;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type CreateObservationInput = {
  conferenceId: Scalars["String"]["input"];
  conferenceName: Scalars["String"]["input"];
  endDate: Scalars["String"]["input"];
  reason: Scalars["String"]["input"];
  requestorEmail: Scalars["String"]["input"];
  requestorName: Scalars["String"]["input"];
  startDate: Scalars["String"]["input"];
};

export type CreateReferralInput = {
  affiliation: Scalars["String"]["input"];
  email: Scalars["String"]["input"];
  expertise?: InputMaybe<Scalars["String"]["input"]>;
  guid?: InputMaybe<Scalars["String"]["input"]>;
  isPersonalContact?: InputMaybe<Scalars["Boolean"]["input"]>;
  name: Scalars["String"]["input"];
  origin?: InputMaybe<Scalars["String"]["input"]>;
  reason: Scalars["String"]["input"];
  referralSource?: InputMaybe<Scalars["String"]["input"]>;
  willContact?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type DeleteAccountResult = {
  __typename?: "DeleteAccountResult";
  requestedAt: Scalars["String"]["output"];
  success: Scalars["Boolean"]["output"];
};

export enum DeviceTokenPlatform {
  Apns = "APNS",
  Fcm = "FCM",
}

export type DossierInformation = {
  __typename?: "DossierInformation";
  bio?: Maybe<Scalars["String"]["output"]>;
  controversialViewDescription?: Maybe<Scalars["String"]["output"]>;
  economicsViewDescription?: Maybe<Scalars["String"]["output"]>;
  libertyViewDescription?: Maybe<Scalars["String"]["output"]>;
  socialLinks?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  urlSources?: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type Event = Node & {
  __typename?: "Event";
  /**
   * Asset-proxy URL for the board conference document (proposal PDF).
   * Keyed by the conference E-Number; the asset proxy derives the underlying
   * document server-side, so the Salesforce record ID is never exposed. Null
   * when no document is set. Board-review data — narrower than Event's
   * type-level gate (see totalBudget above for the same rationale).
   */
  boardDocumentUrl?: Maybe<Scalars["String"]["output"]>;
  /**
   * Whether the conferee (participant) list has been published for this event.
   * Backed by the Salesforce checkbox Conferee_List_Available__c, so it is always
   * true or false — never null — and every Event resolver populates it.
   */
  confereeListAvailable: Scalars["Boolean"]["output"];
  description?: Maybe<Scalars["String"]["output"]>;
  directorDisplay?: Maybe<Scalars["String"]["output"]>;
  eNumber: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["String"]["output"]>;
  fiscalYear?: Maybe<Scalars["String"]["output"]>;
  /**
   * Honorarium review data for this conference. Gated by
   * `read:EventHonorarium` so approvers / auditors can see honoraria
   * fields without broadening general Event access.
   */
  honorarium?: Maybe<EventHonorarium>;
  id: Scalars["ID"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  introVideoUrl?: Maybe<Scalars["String"]["output"]>;
  myTravelInfo?: Maybe<TravelInfo>;
  /**
   * Participants in scope under the shared participant rule: registered
   * (Registration Completed / Attended) plus the status-exempt staff and
   * observer types. The rule is enforced server-side as a floor — the
   * `statuses` argument narrows within it but can never widen past it.
   *
   * Tier B (@scope): no rule needed. Row authorization here is already carried
   * by the participant-scope floor above (unconditional, not shadow-able) plus
   * the per-event Conferee_List_Available__c publication gate
   * (EventParticipantMapper.applyFilters) — both independent of and orthogonal
   * to entitlement-based event scoping. An EVENT_MEMBER/EVENT_REP @scope on top
   * would be redundant with the publication gate for concierge callers and wrong
   * for portal:board:*\/portal:honorarium:* (who must see participant lists
   * board/honorarium-wide, not just their own events). So under the
   * narrowing-only model this field carries no @scope rule → OPEN for its
   * admitted callers.
   */
  participantConnection?: Maybe<EventParticipantConnection>;
  planner?: Maybe<Person>;
  programMaterialsAddress?: Maybe<Address>;
  projectedQuarter?: Maybe<Scalars["String"]["output"]>;
  readerAvailable?: Maybe<Scalars["Boolean"]["output"]>;
  readersLink?: Maybe<Scalars["String"]["output"]>;
  region?: Maybe<Scalars["String"]["output"]>;
  representative?: Maybe<Person>;
  scheduleAvailable?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * Tier B (@scope): no rule needed. Session schedules are gated by the
   * per-event Schedule_Available__c publication flag
   * (EventSessionMapper.applyFilters), with board/honorarium roles bypassing it
   * to review pre-publication — the same orthogonal-gate reasoning as
   * `participantConnection` above applies. Under the narrowing-only model, no
   * @scope rule → OPEN for its admitted callers.
   */
  sessionsConnection?: Maybe<EventSessionConnection>;
  shortTitle?: Maybe<Scalars["String"]["output"]>;
  startDate?: Maybe<Scalars["String"]["output"]>;
  status?: Maybe<EventStatus>;
  subRegion?: Maybe<Scalars["String"]["output"]>;
  /**
   * Intacct payment-method lookup for this conference's participants that
   * have an Intacct vendor ID, keyed by vendorId. A live Intacct API call,
   * not a Salesforce field — join against
   * EventParticipantEdge.accountInfo.intacctVendorId client-side.
   */
  taxVendorPaymentMethods: Array<TaxVendorPaymentMethod>;
  title: Scalars["String"]["output"];
  /**
   * Total budget for the conference. Board-review data — narrower than
   * Event's type-level gate (which also admits portal:board:viewer via
   * portal:*); the portal currently hides this client-side for viewers,
   * but the server should not rely on that.
   */
  totalBudget?: Maybe<Scalars["Float"]["output"]>;
  /**
   * The complement of `participantConnection`: CampaignMembers outside
   * the participant-scope rule — pending invitations, cancellations, and
   * unrecognized statuses. Gated by UnconfirmedParticipantConnection's
   * type-level @roles to portal:board:approver / portal:board:requestor
   * (matches the conference-detail UI). Callers are expected to also hold
   * `read:UnpublishedEventContent` — the conferee-list publication gate
   * applies here too, and unpublished events otherwise return empty
   * edges.
   *
   * Tier B (@scope): no rule needed — admitted callers see the full pending
   * bucket for events they can reach (no per-caller entitlement filter).
   */
  unconfirmedParticipantConnection?: Maybe<UnconfirmedParticipantConnection>;
  venue?: Maybe<Venue>;
  /**
   * The CALLING viewer's own participant role(s) on THIS event — e.g. "you
   * are a Discussion Leader here". Drives app UI (self-context banners,
   * conditional actions) rather than exposing another person's row, so it
   * is resolved entirely from the caller's own cached
   * `ViewerEntitlements[eNumber].participationTypes`
   * (packages/shared/salesforce/viewerEntitlements.ts) mapped through the
   * same `mapParticipationTypeToRoles` helper `EventParticipantEdge.roles`/
   * `PersonEventEdge.roles` use — never a fresh Salesforce query. Empty
   * array when the viewer has no entitlement for this event (including
   * service/M2M tokens, which have no viewer GUID).
   *
   * NOT annotated with `@scope` and deliberately EXEMPT from the "every
   * scopable field must declare @scope" completeness gate (Phase 3B,
   * later): this field returns only the CALLER's own enum values, never
   * another person's Salesforce row data, and is not a Query root or
   * `*Connection` field — there is no "which rows may a caller see" question
   * to answer here, only "what does the caller already know about
   * themselves". Inherits Event's type-level @roles.
   */
  viewerRoles: Array<ParticipantRole>;
};

export type EventParticipantConnectionArgs = {
  statuses?: InputMaybe<Array<InputMaybe<ParticipantStatus>>>;
  types?: InputMaybe<Array<InputMaybe<ParticipantRole>>>;
};

export type EventUnconfirmedParticipantConnectionArgs = {
  types?: InputMaybe<Array<InputMaybe<ParticipantRole>>>;
};

/**
 * Honorarium review bundle for an Event. Holds the conference-level
 * honoraria fields and the filtered participant connection. Per-participant
 * honoraria / accounting data lives on EventParticipantEdge.honorariaInfo /
 * .accountInfo so the same connection type can be used everywhere.
 */
export type EventHonorarium = {
  __typename?: "EventHonorarium";
  /** Count of open Payment_Information rows on the conference (Campaign.Incomplete_Payment__c). */
  incompletePaymentCount?: Maybe<Scalars["Int"]["output"]>;
  /**
   * Valid participants on this conference that have at least one
   * Incomplete Payment_Information row with Fee > 0. Reuses the standard
   * EventParticipantConnection — honoraria-specific values are exposed
   * via `edges.honorariaInfo` / `edges.accountInfo`, each gated by its
   * own RBAC permission.
   *
   * Tier B (@scope): no rule needed. This field is reached only through
   * `Event.honorarium`, itself gated to the honorarium roles — by the time a
   * caller is here they already hold one, and the honorarium review workflow is
   * conference-wide for that role (an approver reviewing payment records needs
   * the incomplete-payment participants for whichever conference they opened,
   * not just conferences where they are personally the LF Rep — that narrower
   * EVENT_REP scoping applies to `Query.honorariumConferences`, the LIST entry
   * point, not this per-conference detail connection). Under the narrowing-only
   * model, carrying no `@scope` rule means OPEN (no row restriction) for the
   * admitted callers — which is exactly this workflow's intent.
   */
  participantsConnection?: Maybe<EventParticipantConnection>;
};

export type EventParticipantConnection = {
  __typename?: "EventParticipantConnection";
  edges: Array<EventParticipantEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type EventParticipantEdge = {
  __typename?: "EventParticipantEdge";
  /**
   * Accounting / tax compliance data for this participant. Gated
   * separately by `read:ParticipantAccountInfo` — null for callers
   * without that permission.
   */
  accountInfo?: Maybe<ParticipantAccountInfo>;
  cursor: Scalars["String"]["output"];
  /**
   * Government-position tax questionnaire for this participant (IRS
   * withholding-determination questions). Gated separately by
   * `read:ParticipantGovernmentForm` — null for callers without that
   * permission. Tax Forms only; not needed by board/honorarium reviewers.
   */
  governmentForm?: Maybe<ParticipantGovernmentForm>;
  /**
   * Honorarium review data for this participant. Gated separately by
   * `read:ParticipantHonorariaInfo` — null for callers without that
   * permission.
   */
  honorariaInfo?: Maybe<ParticipantHonorariaInfo>;
  /**
   * Raw Salesforce Inv_Status__c, verbatim (e.g. "Invitation Declined",
   * "Polling Sent", "Registration Sent"). Use this for exact display and
   * bucketing; `status` is the lossy coarse enum intended for filtering.
   * Blank/null when Salesforce has no invitation status (e.g. status-exempt
   * observer/rep/planner roles).
   */
  invitationStatus?: Maybe<Scalars["String"]["output"]>;
  node?: Maybe<Person>;
  otherRole?: Maybe<Scalars["String"]["output"]>;
  roles: Array<ParticipantRole>;
  status: ParticipantStatus;
  /**
   * Tax Forms data for this participant (needs-attention flag and full
   * fee history). Gated separately by `read:ParticipantTaxInfo` — null
   * for callers without that permission. Honorarium reviewers use
   * `honorariaInfo.payments` (Incomplete-only).
   */
  taxInfo?: Maybe<ParticipantTaxInfo>;
};

export type EventSessionConnection = {
  __typename?: "EventSessionConnection";
  edges: Array<EventSessionEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type EventSessionEdge = {
  __typename?: "EventSessionEdge";
  cursor: Scalars["String"]["output"];
  node?: Maybe<Session>;
};

export enum EventStatus {
  Completed = "COMPLETED",
  Pending = "PENDING",
  Scheduled = "SCHEDULED",
  Unknown = "UNKNOWN",
}

export enum EventType {
  Conference = "CONFERENCE",
  Cosponsored = "COSPONSORED",
  Dinner = "DINNER",
  GeorgeWill = "GEORGE_WILL",
  Mps = "MPS",
  Unknown = "UNKNOWN",
  Virtual = "VIRTUAL",
}

/**
 * A point on the globe in WGS84 decimal degrees. Backed by Salesforce's
 * geocoded address fields (populated by the org's geocoding Data Integration
 * Rules), so it is null wherever Salesforce hasn't geocoded the address.
 */
export type GeoPoint = {
  __typename?: "GeoPoint";
  latitude: Scalars["Float"]["output"];
  longitude: Scalars["Float"]["output"];
};

export type HonorariumPayment = {
  __typename?: "HonorariumPayment";
  fee?: Maybe<Scalars["Float"]["output"]>;
  id: Scalars["ID"]["output"];
  participantType?: Maybe<Scalars["String"]["output"]>;
  paymentDeclined?: Maybe<Scalars["Boolean"]["output"]>;
  paymentNote?: Maybe<Scalars["String"]["output"]>;
  paymentStatus?: Maybe<Scalars["String"]["output"]>;
  programName?: Maybe<Scalars["String"]["output"]>;
  taxWithholdingPercentage?: Maybe<Scalars["Float"]["output"]>;
};

export type InboxConnection = {
  __typename?: "InboxConnection";
  items: Array<InboxItem>;
  nextToken?: Maybe<Scalars["String"]["output"]>;
  totalUnreadCount: Scalars["Int"]["output"];
};

export type InboxItem = {
  __typename?: "InboxItem";
  attachments?: Maybe<Array<Attachment>>;
  id: Scalars["ID"]["output"];
  preview?: Maybe<Scalars["String"]["output"]>;
  priority?: Maybe<MessagePriority>;
  read?: Maybe<Scalars["Boolean"]["output"]>;
  senderAvatar?: Maybe<Scalars["String"]["output"]>;
  senderId?: Maybe<Scalars["String"]["output"]>;
  senderName?: Maybe<Scalars["String"]["output"]>;
  timestamp: Scalars["String"]["output"];
  title?: Maybe<Scalars["String"]["output"]>;
  type: InboxItemType;
};

export enum InboxItemType {
  Conversation = "CONVERSATION",
  OneWayMessage = "ONE_WAY_MESSAGE",
}

/**
 * The LibertyAI agent's processing state for a conversation, delivered with
 * each onLibertyAINotification signal.
 */
export enum LibertyAiAgentState {
  Error = "ERROR",
  Idle = "IDLE",
  Working = "WORKING",
}

/**
 * A LibertyAI conversation. Messages are paginated via messagesConnection
 * rather than returned inline, so a conversation with a long history stays
 * cheap to list.
 */
export type LibertyAiConversation = {
  __typename?: "LibertyAIConversation";
  createdAt: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  /**
   * When the caller last marked this conversation as read. Null if never
   * marked read. Compare against updatedAt to determine unread state --
   * there is no separate boolean field, to avoid two sources of truth.
   */
  lastReadAt?: Maybe<Scalars["String"]["output"]>;
  messagesConnection: LibertyAiMessageConnection;
  /** User-set name, if any. Null until renameLibertyAIConversation is called. */
  name?: Maybe<Scalars["String"]["output"]>;
  /** The agent's current processing state for this conversation. */
  state: LibertyAiAgentState;
  /** Optional human-readable status text (e.g. "Searching archives..."). */
  statusMessage?: Maybe<Scalars["String"]["output"]>;
  updatedAt: Scalars["String"]["output"];
};

/** A single message within a LibertyAI conversation. */
export type LibertyAiMessage = {
  __typename?: "LibertyAIMessage";
  /**
   * Structured message blocks (optional). JSON-encoded content for rich
   * results (citations, tool calls, etc). Parse on client as needed.
   */
  blocks?: Maybe<Scalars["AWSJSON"]["output"]>;
  conversationId: Scalars["ID"]["output"];
  id: Scalars["ID"]["output"];
  /** Who sent this message. */
  role: LibertyAiMessageRole;
  /** Human-readable message text. */
  text?: Maybe<Scalars["String"]["output"]>;
  timestamp: Scalars["String"]["output"];
};

export type LibertyAiMessageConnection = {
  __typename?: "LibertyAIMessageConnection";
  edges: Array<LibertyAiMessageEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type LibertyAiMessageEdge = {
  __typename?: "LibertyAIMessageEdge";
  cursor: Scalars["String"]["output"];
  node: LibertyAiMessage;
};

/**
 * Result of sendLibertyAIMessage. Returns the conversationId so the client
 * can track the conversation and pass it back in to post follow-up messages.
 */
export type LibertyAiMessageResult = {
  __typename?: "LibertyAIMessageResult";
  /**
   * Conversation identifier. Stable across requests — pass this back in as
   * conversationId to continue the conversation; omit to start a new one.
   */
  conversationId: Scalars["ID"]["output"];
};

export enum LibertyAiMessageRole {
  Assistant = "ASSISTANT",
  User = "USER",
}

/**
 * Notification that the LibertyAI assistant has an update for one of this
 * user's conversations. Delivered via the onLibertyAINotification
 * subscription — mirrors UserNotification/onUserNotification. Carries the
 * agent's current state, not message content: clients refetch via
 * libertyAIConversations to get the actual message.
 */
export type LibertyAiNotification = {
  __typename?: "LibertyAINotification";
  /** Conversation with a new update — fetch it via libertyAIConversations. */
  conversationId: Scalars["ID"]["output"];
  /** The agent's current processing state for this conversation. */
  state: LibertyAiAgentState;
  /** Optional human-readable status text (e.g. "Searching archives..."). */
  statusMessage?: Maybe<Scalars["String"]["output"]>;
  timestamp: Scalars["String"]["output"];
  /** User this notification is for. */
  userId: Scalars["ID"]["output"];
};

export type ListChoice = {
  __typename?: "ListChoice";
  label: Scalars["String"]["output"];
  value: Scalars["String"]["output"];
};

export enum MessagePriority {
  Feedback = "FEEDBACK",
  Normal = "NORMAL",
  Urgent = "URGENT",
}

export type Mutation = {
  __typename?: "Mutation";
  /**
   * Adds a conference to the caller's watchlist. Idempotent — adding an
   * already-watched conference returns the existing interest.
   */
  addConferenceInterest: ConferenceInterest;
  /**
   * Transitions one or more pending observation requests to "Approved" in
   * Jira. Replaces /api/board/approve-observations. Every issue key is
   * attempted independently and its own result reported back — the legacy
   * REST route fired all transitions in an un-awaited loop with no per-key
   * error handling.
   */
  approveObservations: ApproveObservationsResult;
  createConversation: CreateConversationResult;
  /**
   * Creates a new observation request in Jira for an upcoming conference.
   * Replaces /api/board/create-observation.
   */
  createObservationRequest: Observation;
  createReferral: Referral;
  /**
   * Delete a conversation the caller owns, and all of its messages. Returns
   * true if deleted, false if the id didn't exist or wasn't owned by the
   * caller (same never-confirm-which pattern as sendLibertyAIMessage).
   */
  deleteLibertyAIConversation: Scalars["Boolean"]["output"];
  /**
   * Irreversibly deletes the caller's own account. Removes the AWS-stored
   * profile row, inbox items, and push device tokens, then deletes the
   * Auth0 user. Salesforce records are never touched. Returns as soon as
   * the request is accepted; the purge runs asynchronously, so the client
   * should sign out immediately.
   */
  deleteMyAccount: DeleteAccountResult;
  /**
   * Clears a tax document's URL/validity fields on the conferee's Contact
   * record. Does NOT delete the underlying S3 object — matches the legacy
   * /api/tax-forms/delete-pdf-form REST route's behavior exactly. Replaces
   * PATCH /services/apexrest/confereeDocumentUpdate (delete path).
   */
  deleteTaxDocument: UpdateResult;
  markInboxItemRead?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * Backend-only mutation (IAM auth) that triggers the onLibertyAINotification
   * subscription. Called by LibertyAINotificationProcessor (an EventBridge
   * target Lambda in this account) when the LibertyAI agent publishes a
   * status update event. Carries the agent's state — not message content;
   * clients refetch via libertyAIConversations for the actual message.
   */
  notifyLibertyAI: LibertyAiNotification;
  /**
   * Backend-only mutation (IAM auth) that triggers the onUserNotification
   * subscription. Called by MessageProcessor for each recipient when a new
   * message arrives. Bare signal — no message data, just userId.
   */
  notifyUser: UserNotification;
  registerDeviceToken: RegisterDeviceTokenResult;
  /**
   * Removes a conference from the caller's watchlist. Idempotent —
   * removing a conference that isn't watched still succeeds. Other
   * participation the caller has on the conference (Director, Conferee,
   * ...) is never touched.
   */
  removeConferenceInterest: RemoveConferenceInterestResult;
  /**
   * Set (or clear, with an empty string) a caller-owned conversation's display
   * name. Returns the updated conversation.
   */
  renameLibertyAIConversation: LibertyAiConversation;
  requestAddressChange: AddressChangeResult;
  sendConversationMessage: ConversationMessage;
  /**
   * Send a message to the LibertyAI assistant. Returns the conversationId so
   * the client can track the conversation and post follow-up messages by
   * passing it back in as conversationId. The assistant's reply arrives later
   * via the onLibertyAINotification subscription — fetch it via
   * libertyAIConversations once notified.
   */
  sendLibertyAIMessage: LibertyAiMessageResult;
  sendOneWayMessage: SendMessageResult;
  /**
   * Set a caller-owned conversation's read state. Pass read: true to mark as
   * read (sets lastReadAt to now), or read: false to mark as unread (clears
   * lastReadAt). Returns the updated conversation.
   */
  setLibertyAIConversationReadState: LibertyAiConversation;
  /**
   * Submit honoraria for a conference. Auditor (allow) unrestricted; approver
   * (identityOnly) must be LF Rep for conferenceId. Denied writes are rejected.
   *
   * When documentId is omitted (or empty), the backend generates the
   * honorarium PDF and creates the Intacct attachment automatically before
   * creating bills. When provided, it is used directly as the SUPDOCID on
   * Intacct bills (legacy client-side PDF path).
   *
   * The PDF's "Approver: <name> <date>, <time>" stamp is derived server-side
   * from the caller's identity (never a client-supplied argument — any
   * auditor/approver allowed to call this mutation could otherwise
   * attribute the financial document to an arbitrary name).
   *
   * This is the only call needed to submit honoraria. It takes the submitted
   * payments out of the Honorarium app and returns as soon as processing is
   * queued; the payments' Salesforce status (Paid / Unpaid) is only written once
   * the Intacct bills have been attempted, and a payment whose bill failed stays
   * Incomplete. A submission is rejected while another one for the same
   * conference is being processed. Payments are not checked here: one already
   * settled by an earlier submission is left alone when the submission is
   * processed, and if none is left to process, the outcome says nothing was
   * processed.
   */
  submitHonorarium: SubmitHonorariumResult;
  /**
   * Toggles the "needs tax audit attention" flag on a conferee. Replaces
   * PATCH /services/apexrest/campaignmember/taxaudit.
   */
  updateConfereeNeedsAttention: UpdateResult;
  /**
   * Updates a conferee's tax/finance details (work visa, government
   * official flag, finance notes, payment eligibility, Intacct vendor id)
   * plus per-payment tax-withholding percentages and decline status.
   * Replaces PATCH /services/apexrest/updateParticipantDetails. When
   * paymentEligible is provided, Payment_Eligible_Updated_Date__c is
   * stamped with today's date server-side (matches the legacy route — not
   * client-writable). intacctVendorId is trimmed, capped at 20 characters,
   * and rejected if another Contact already holds it — matching the legacy
   * route's validation exactly (Intacct routes payments by vendor ID; two
   * contacts sharing one would misroute a payment).
   */
  updateConfereeTaxDetails: UpdateResult;
  /**
   * Update reviewer notes (CampaignMember.Honoraria_Notes__c) for one or more
   * conferees on a conference. Replaces the legacy Apex REST endpoint
   * POST /services/apexrest/honorariumInfo. Same @scope binding as
   * submitHonorarium / honorariumConferences: auditor (allow) unrestricted;
   * approver (identityOnly) must be LF Rep for eNumber. Denied writes are
   * rejected, not silently no-op'd.
   */
  updateHonorariumNotes: UpdateHonorariumNotesResult;
  /**
   * Deprecated: a no-op that returns success. Payment status is now written by
   * the backend once bills have been created, as part of submitHonorarium, so
   * a client call here must not change it. Kept only so clients that still
   * call it after submitHonorarium keep working; to be removed.
   * @deprecated Payment status is written by submitHonorarium's processing. This call does nothing.
   */
  updateHonorariumPaymentStatus: UpdateHonorariumPaymentStatusResult;
  updatePersonalInfo: Profile;
  updatePreferences: ProfilePreferences;
  updateProgramMaterialsAddress?: Maybe<Address>;
  updateSettings: ProfileSettings;
  updateTravelInfo: TravelInfo;
  /**
   * Persists a tax document's URL/validity on the conferee's Contact record
   * after the client has POSTed the PDF to the S3 key issued by
   * taxFormUploadUrl. Verifies the object exists and starts with PDF magic
   * bytes before writing Salesforce. Replaces upload-pdf-form.ts.
   */
  uploadTaxDocument: UpdateResult;
};

export type MutationAddConferenceInterestArgs = {
  eNumber: Scalars["String"]["input"];
};

export type MutationApproveObservationsArgs = {
  issueKeys: Array<Scalars["String"]["input"]>;
};

export type MutationCreateConversationArgs = {
  input: CreateConversationInput;
};

export type MutationCreateObservationRequestArgs = {
  input: CreateObservationInput;
};

export type MutationCreateReferralArgs = {
  input: CreateReferralInput;
};

export type MutationDeleteLibertyAiConversationArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationDeleteTaxDocumentArgs = {
  fileFormat: TaxDocumentFormat;
  guid: Scalars["String"]["input"];
};

export type MutationMarkInboxItemReadArgs = {
  id: Scalars["ID"]["input"];
};

export type MutationNotifyLibertyAiArgs = {
  conversationId: Scalars["ID"]["input"];
  state: LibertyAiAgentState;
  statusMessage?: InputMaybe<Scalars["String"]["input"]>;
  userId: Scalars["ID"]["input"];
};

export type MutationNotifyUserArgs = {
  userId: Scalars["ID"]["input"];
};

export type MutationRegisterDeviceTokenArgs = {
  input: RegisterDeviceTokenInput;
};

export type MutationRemoveConferenceInterestArgs = {
  eNumber: Scalars["String"]["input"];
};

export type MutationRenameLibertyAiConversationArgs = {
  id: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
};

export type MutationRequestAddressChangeArgs = {
  input: RequestAddressChangeInput;
};

export type MutationSendConversationMessageArgs = {
  input: SendConversationMessageInput;
};

export type MutationSendLibertyAiMessageArgs = {
  conversationId?: InputMaybe<Scalars["ID"]["input"]>;
  message: Scalars["String"]["input"];
};

export type MutationSendOneWayMessageArgs = {
  input: SendOneWayMessageInput;
};

export type MutationSetLibertyAiConversationReadStateArgs = {
  id: Scalars["ID"]["input"];
  read: Scalars["Boolean"]["input"];
};

export type MutationSubmitHonorariumArgs = {
  conferees: Array<SubmitHonorariumConfereeInput>;
  conferenceId: Scalars["String"]["input"];
  documentId?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationUpdateConfereeNeedsAttentionArgs = {
  eNumber: Scalars["String"]["input"];
  guid: Scalars["String"]["input"];
  needsAttention: Scalars["Boolean"]["input"];
};

export type MutationUpdateConfereeTaxDetailsArgs = {
  input: UpdateConfereeTaxDetailsInput;
};

export type MutationUpdateHonorariumNotesArgs = {
  eNumber: Scalars["String"]["input"];
  notes: Array<ConfereeNoteInput>;
};

export type MutationUpdateHonorariumPaymentStatusArgs = {
  eNumber: Scalars["String"]["input"];
  paymentUpdates: Array<ConfereePaymentStatusInput>;
};

export type MutationUpdatePersonalInfoArgs = {
  input: UpdatePersonalInfoInput;
};

export type MutationUpdatePreferencesArgs = {
  input: UpdatePreferencesInput;
};

export type MutationUpdateProgramMaterialsAddressArgs = {
  input: UpdateProgramMaterialsAddressInput;
};

export type MutationUpdateSettingsArgs = {
  input: UpdateSettingsInput;
};

export type MutationUpdateTravelInfoArgs = {
  input: UpdateTravelInfoInput;
};

export type MutationUploadTaxDocumentArgs = {
  input: UploadTaxDocumentInput;
};

export type Node = {
  id: Scalars["ID"]["output"];
};

/**
 * A board conference-observation request. Backed by a Jira issue (project
 * TCOR/CORT) enriched with Salesforce conference data.
 */
export type Observation = {
  __typename?: "Observation";
  conferenceId?: Maybe<Scalars["String"]["output"]>;
  endDate?: Maybe<Scalars["String"]["output"]>;
  /** Jira issue key, e.g. TCOR-123. */
  id: Scalars["ID"]["output"];
  location?: Maybe<Scalars["String"]["output"]>;
  requestorEmail?: Maybe<Scalars["String"]["output"]>;
  requestorName?: Maybe<Scalars["String"]["output"]>;
  startDate?: Maybe<Scalars["String"]["output"]>;
  summary?: Maybe<Scalars["String"]["output"]>;
};

export type OneWayMessage = {
  __typename?: "OneWayMessage";
  attachments?: Maybe<Array<Attachment>>;
  body: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  priority?: Maybe<MessagePriority>;
  senderAvatar?: Maybe<Scalars["String"]["output"]>;
  senderId?: Maybe<Scalars["String"]["output"]>;
  senderName?: Maybe<Scalars["String"]["output"]>;
  senderTitle?: Maybe<Scalars["String"]["output"]>;
  subject: Scalars["String"]["output"];
  timestamp: Scalars["String"]["output"];
};

export type PageInfo = {
  __typename?: "PageInfo";
  hasNextPage: Scalars["Boolean"]["output"];
  hasPreviousPage: Scalars["Boolean"]["output"];
};

/**
 * Accounting / tax compliance data attached to an EventParticipantEdge.
 * Holds raw compliance flags, vendor identifiers, and tax document status
 * used by downstream finance integrations and the Tax Forms workflow.
 * Gated by `read:ParticipantAccountInfo`.
 */
export type ParticipantAccountInfo = {
  __typename?: "ParticipantAccountInfo";
  /** CampaignMember.Finance_App_Notes__c — free-text finance/accounting notes. */
  financeAppNotes?: Maybe<Scalars["String"]["output"]>;
  government?: Maybe<Scalars["Boolean"]["output"]>;
  governmentPosition?: Maybe<Scalars["Boolean"]["output"]>;
  /** Contact.Intacct_Vendor_ID__c — vendor ID in the accounting system. */
  intacctVendorId?: Maybe<Scalars["String"]["output"]>;
  paymentEligible?: Maybe<Scalars["Boolean"]["output"]>;
  /** CampaignMember.Payment_Eligible_Updated_Date__c — set server-side by updateConfereeTaxDetails, not client-writable. */
  paymentEligibleUpdatedDate?: Maybe<Scalars["String"]["output"]>;
  /** CampaignMember.SSN_ITIN__c — Yes/No picklist, has an SSN or ITIN on file. */
  ssnItin?: Maybe<Scalars["String"]["output"]>;
  /** CampaignMember.U_S_Citizen__c — Yes/No picklist. */
  usCitizen?: Maybe<Scalars["Boolean"]["output"]>;
  /** CampaignMember.US_Gov_Position__c — true Salesforce checkbox (not a Yes/No picklist). */
  usGovPosition?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * Contact.W8_Document__c. Cleared (returned as null) and written back to
   * Salesforce when W8_Valid_Until__c is before today (PAD-395 / Apex parity).
   */
  w8DocumentUrl?: Maybe<Scalars["String"]["output"]>;
  /** Contact.W8_Valid_Until__c. Null after the valid-until date has passed. */
  w8ValidUntil?: Maybe<Scalars["String"]["output"]>;
  /** Contact.W9_Document__c — W-9 has no expiry field and is never auto-cleared. */
  w9DocumentUrl?: Maybe<Scalars["String"]["output"]>;
  /** Contact.W9_Status__c */
  w9Status?: Maybe<Scalars["String"]["output"]>;
  workVisa?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * Contact.X8233_Document__c. Cleared (returned as null) and written back to
   * Salesforce when X8233_Valid_Until__c is before today (PAD-395 / Apex parity).
   */
  x8233DocumentUrl?: Maybe<Scalars["String"]["output"]>;
  /** Contact.X8233_Valid_Until__c. Null after the valid-until date has passed. */
  x8233ValidUntil?: Maybe<Scalars["String"]["output"]>;
};

/**
 * Government-position tax questionnaire for a conference participant —
 * drives IRS withholding-determination on honoraria payments. All boolean
 * fields are true Salesforce checkboxes (not Yes/No picklists).
 */
export type ParticipantGovernmentForm = {
  __typename?: "ParticipantGovernmentForm";
  /** CampaignMember.Armed_Forces_Position__c */
  armedForcesPosition?: Maybe<Scalars["Boolean"]["output"]>;
  /** CampaignMember.Assistant_to_Officials__c */
  assistantToOfficials?: Maybe<Scalars["Boolean"]["output"]>;
  /** CampaignMember.CitizenshipResidence__c */
  citizenshipResidence?: Maybe<Scalars["String"]["output"]>;
  /** CampaignMember.Compensation_132_552__c */
  compensationAboveThreshold?: Maybe<Scalars["Boolean"]["output"]>;
  /** CampaignMember.Congress_Employee_15K__c */
  congressEmployeeAboveOrEq15k?: Maybe<Scalars["Boolean"]["output"]>;
  /** CampaignMember.CountryResidenceTaxPurpose__c */
  countryOfResidenceTaxPurpose?: Maybe<Scalars["String"]["output"]>;
  /** CampaignMember.Elective_Office_US__c */
  electiveOfficeUS?: Maybe<Scalars["Boolean"]["output"]>;
  /** CampaignMember.IRS_Oversight_Member__c */
  irsOversightMember?: Maybe<Scalars["Boolean"]["output"]>;
  /** CampaignMember.Military_Academy_Professor__c */
  militaryAcademyProfessor?: Maybe<Scalars["Boolean"]["output"]>;
  /** CampaignMember.Position_Held__c */
  positionHeld?: Maybe<Scalars["String"]["output"]>;
  /** CampaignMember.Presidential_Appointment__c */
  presidentialAppointment?: Maybe<Scalars["Boolean"]["output"]>;
  /** CampaignMember.Public_Office_20K__c */
  publicOfficeAboveOrEq20k?: Maybe<Scalars["Boolean"]["output"]>;
  /** CampaignMember.Schedule_C_Position__c */
  scheduleCPosition?: Maybe<Scalars["Boolean"]["output"]>;
  /** CampaignMember.Special_Gov_Employee__c */
  specialGovEmployee?: Maybe<Scalars["Boolean"]["output"]>;
};

/**
 * Honorarium workflow data attached to an EventParticipantEdge. Contains
 * the notes and Incomplete payment rows a reviewer needs. Gated by
 * `read:ParticipantHonorariaInfo`. Tax Forms fee history and the
 * needs-attention flag live on `EventParticipantEdge.taxInfo`.
 */
export type ParticipantHonorariaInfo = {
  __typename?: "ParticipantHonorariaInfo";
  /** CampaignMember.Honoraria_Notes__c — planner / reviewer notes. */
  honorariaNotes?: Maybe<Scalars["String"]["output"]>;
  /** Incomplete payment rows (Fee > 0) attached to this participant on this conference. */
  payments: Array<HonorariumPayment>;
};

/**
 * Participant role on an event. Sourced entirely from
 * `CampaignMember.Participation_Type__c` (multi-select picklist), with
 * one refinement layered on top:
 *
 *   * `Role_Name__c` (free-form alternate role name on CampaignMember) is
 *     consulted when `Participation_Type__c` includes 'Other' to promote
 *     known canonical strings (Assistant, Program Officer, Author, …) to
 *     their own enum values. The raw string remains available on
 *     `EventParticipantEdge.otherRole` for values the mapper does not
 *     recognize.
 *
 * Rep and planner status both come from first-class picklist values
 * ('LF Rep' → `REP`, 'LF Planner' → `PLANNER`). The earlier
 * Campaign-level email-match injection (which was the only source of the
 * now-retired `LF_REP`) has been removed.
 */
export enum ParticipantRole {
  /** `Role_Name__c = 'Assistant'`. */
  Assistant = "ASSISTANT",
  /** `Role_Name__c = 'Author'`. */
  Author = "AUTHOR",
  /** 'LF Board Observer' picklist value. */
  Board = "BOARD",
  Conferee = "CONFEREE",
  Director = "DIRECTOR",
  DiscussionLeader = "DISCUSSION_LEADER",
  /** `Role_Name__c = 'Lecturer'`. */
  Lecturer = "LECTURER",
  /** 'External LF Rep' picklist value on `Participation_Type__c`. */
  LfExtRep = "LF_EXT_REP",
  /**
   * RETIRED — no longer produced. Previously resolver-injected by matching
   * `Contact.Email` to `Campaign.pep_Representative__r.Email`. Rep status
   * now comes from the 'LF Rep' picklist value via `REP`. The enum value
   * is retained for backward compatibility with clients that still
   * reference it, but no participant edge will carry it.
   */
  LfRep = "LF_REP",
  /** Generic 'Observer' (`Participation_Type__c` contains 'Observer' but not 'Board Observer'). */
  Observer = "OBSERVER",
  /** Catch-all when `Participation_Type__c` contains 'Other' and no canonical sub-role is recognized from `Role_Name__c`. */
  Other = "OTHER",
  /**
   * Event planner: the 'LF Planner' picklist value on
   * `Participation_Type__c`. A Director who is also the event's planner
   * gets both DIRECTOR and PLANNER. (Previously resolver-injected from
   * `Campaign.inv_Planner__c`; now a first-class picklist value.)
   */
  Planner = "PLANNER",
  /** `Role_Name__c = 'Program Officer'`. */
  ProgramOfficer = "PROGRAM_OFFICER",
  /** LF conference team member: the 'LF Rep' picklist value on `Participation_Type__c`. This is the canonical rep role; the formerly-injected `LF_REP` is retired. */
  Rep = "REP",
  /** `Role_Name__c = 'Speaker'`. */
  Speaker = "SPEAKER",
  /** Composite, query-only alias for the Tax Forms app's participant set: expands to `[DIRECTOR, DISCUSSION_LEADER, CONFEREE, OTHER]` (Apex-parity role set). Never appears in a returned `roles` list — request-only, like requesting the four roles individually. */
  Tax = "TAX",
  /** `Role_Name__c = 'Translator'`. */
  Translator = "TRANSLATOR",
}

export enum ParticipantStatus {
  Attended = "ATTENDED",
  Cancelled = "CANCELLED",
  Confirmed = "CONFIRMED",
  Pending = "PENDING",
  Unknown = "UNKNOWN",
}

/**
 * Tax Forms data on an EventParticipantEdge: the needs-attention flag and
 * full Payment_Information fee history (no Payment_Status__c / Fee__c
 * filter). Gated by `read:ParticipantTaxInfo` so tax-forms callers do not
 * go through honorariaInfo.
 */
export type ParticipantTaxInfo = {
  __typename?: "ParticipantTaxInfo";
  /**
   * Every Payment_Information row attached to this participant on this
   * conference, regardless of Payment_Status__c. Distinct from
   * `ParticipantHonorariaInfo.payments`, which is Incomplete-only for
   * the Honorarium reviewer workflow.
   */
  allPayments: Array<TaxFormPayment>;
  /**
   * CampaignMember.InvitationModifiedFields__c — comma-separated names of
   * the fields the invitee changed on their registration/invitation, or
   * null when nothing was changed. Drives the "has modified fields?"
   * indicator on the Tax Forms conferee list, the warning icon next to
   * View Registration, and the highlighted Modified Fields value on the
   * Registration Details page. See PAD-2 / cloud-apps#684 for the original
   * implementation this restores after the REST→GraphQL migration dropped
   * the field from the selection set.
   */
  modifiedFields?: Maybe<Scalars["String"]["output"]>;
  /** CampaignMember.Needs_Tax_Audit_Attention__c — rollup flag for tax review. */
  needsTaxAuditAttention?: Maybe<Scalars["Boolean"]["output"]>;
};

export type PaymentTaxWithholdingInput = {
  /** 'Yes'/'No' — Payment_Information__c.Payment_Declined__c, a string field (not boolean) matching Salesforce's picklist. */
  paymentDeclined?: InputMaybe<Scalars["String"]["input"]>;
  paymentInformationId: Scalars["String"]["input"];
  taxWithholding: Scalars["Float"]["input"];
};

export type Person = Node & {
  __typename?: "Person";
  /**
   * The person's geocoded mailing address rounded to whole degrees (about
   * 100 km), for plotting where attendees come from without revealing the
   * address itself. Deliberately NOT identityOnly: it's coarse enough to share
   * across board roles, unlike the exact mailing* fields above. Exact
   * coordinates (Contact.MailingLatitude/MailingLongitude) are never exposed.
   * Null until Salesforce has geocoded the address.
   */
  approximateLocation?: Maybe<GeoPoint>;
  assistantEmail?: Maybe<Scalars["String"]["output"]>;
  assistantName?: Maybe<Scalars["String"]["output"]>;
  /** Conferences attended as Director (Count_as_Director__c). */
  attendedAsDirectorCount?: Maybe<Scalars["Int"]["output"]>;
  /** Conferences attended as Discussion Lead (Count_as_Disc_Lead__c). */
  attendedAsDiscussionLeadCount?: Maybe<Scalars["Int"]["output"]>;
  /**
   * Count of conferences attended (Total_Attended_Conferences_Only__c).
   * Distinct from `conferencesAttendedCount`, which is backed by the
   * broader Total_Conferences_Attended__c rollup.
   */
  attendedConferencesOnlyCount?: Maybe<Scalars["Int"]["output"]>;
  conferencesAttendedCount?: Maybe<Scalars["Int"]["output"]>;
  correspondenceEmail?: Maybe<Scalars["String"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  dossierInformation?: Maybe<DossierInformation>;
  email?: Maybe<Scalars["String"]["output"]>;
  eventsConnection?: Maybe<PersonEventConnection>;
  firstName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  lastName?: Maybe<Scalars["String"]["output"]>;
  mailingCity?: Maybe<Scalars["String"]["output"]>;
  mailingCountry?: Maybe<Scalars["String"]["output"]>;
  mailingPostalCode?: Maybe<Scalars["String"]["output"]>;
  mailingState?: Maybe<Scalars["String"]["output"]>;
  mailingStreet?: Maybe<Scalars["String"]["output"]>;
  middleName?: Maybe<Scalars["String"]["output"]>;
  mostRecentAttendedDate?: Maybe<Scalars["String"]["output"]>;
  name?: Maybe<Scalars["String"]["output"]>;
  /** Contact classification picklist (Person_Type__c), e.g. academic discipline. */
  personType?: Maybe<Scalars["String"]["output"]>;
  phone?: Maybe<Scalars["String"]["output"]>;
  phoneType?: Maybe<Scalars["String"]["output"]>;
  primaryAffiliation?: Maybe<Scalars["String"]["output"]>;
  primaryAffiliationTitle?: Maybe<Scalars["String"]["output"]>;
  primaryExpertise?: Maybe<Scalars["String"]["output"]>;
  /**
   * Pending affiliation change submitted from the app, awaiting staff review.
   * When non-empty, the client should display this value in place of
   * `primaryAffiliation` and indicate that the change has not yet been confirmed.
   * Name matches the `proposedAffiliationName` field on `UpdatePersonalInfoInput`.
   */
  proposedAffiliationName?: Maybe<Scalars["String"]["output"]>;
  /**
   * Pending affiliation-title change submitted from the app, awaiting staff
   * review. When non-empty, the client should display this value in place of
   * `primaryAffiliationTitle` and indicate that the change has not yet been
   * confirmed.
   */
  proposedAffiliationTitle?: Maybe<Scalars["String"]["output"]>;
  publicBio?: Maybe<Scalars["String"]["output"]>;
  publicEmail?: Maybe<Scalars["String"]["output"]>;
  /**
   * The person's public-facing name (Contact.Display_Name__c), self-chosen via
   * the profile preferences screen and intended for name tags and table
   * signage. Mirrors the public/private pattern of `publicEmail`/`email`: when
   * present, clients should prefer this over the firstName/lastName-derived
   * `name`. Null when the person has not set one.
   */
  publicName?: Maybe<Scalars["String"]["output"]>;
  salutation?: Maybe<Scalars["String"]["output"]>;
  /**
   * Fiscal-year strategy-category tier assignments (the portal people
   * module's "Strategic Tier History"), newest fiscal year first. Clients
   * filter by `category` (e.g. "Conference") as needed.
   */
  strategicCategories?: Maybe<Array<StrategicCategory>>;
  suffix?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
  websiteUrl?: Maybe<Scalars["String"]["output"]>;
};

export type PersonEventsConnectionArgs = {
  eventStatuses?: InputMaybe<Array<InputMaybe<EventStatus>>>;
  eventTypes?: InputMaybe<Array<InputMaybe<EventType>>>;
  participantRoles?: InputMaybe<Array<InputMaybe<ParticipantRole>>>;
  participantStatuses?: InputMaybe<Array<InputMaybe<ParticipantStatus>>>;
};

export type PersonEventConnection = {
  __typename?: "PersonEventConnection";
  edges: Array<PersonEventEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type PersonEventEdge = {
  __typename?: "PersonEventEdge";
  cursor: Scalars["String"]["output"];
  /**
   * Raw Salesforce Inv_Status__c, verbatim (e.g. "Invitation Declined",
   * "Polling Sent", "Registration Sent"). Use this for exact display and
   * bucketing; `status` is the lossy coarse enum intended for filtering.
   * Blank/null when Salesforce has no invitation status (e.g. status-exempt
   * observer/rep/planner roles).
   */
  invitationStatus?: Maybe<Scalars["String"]["output"]>;
  node: Event;
  /** Raw Role_Name__c when the participation type is OTHER. */
  otherRole?: Maybe<Scalars["String"]["output"]>;
  /** The person's roles on this event, mirroring EventParticipantEdge.roles. */
  roles: Array<ParticipantRole>;
  /** Lossy participant status derived from Salesforce Inv_Status__c (use invitationStatus for verbatim display/bucketing). */
  status: ParticipantStatus;
};

export type Profile = Node & {
  __typename?: "Profile";
  addressRequestInProgress?: Maybe<Scalars["Boolean"]["output"]>;
  id: Scalars["ID"]["output"];
  initialRoles?: Maybe<Array<Scalars["String"]["output"]>>;
  preferences?: Maybe<ProfilePreferences>;
  settings?: Maybe<ProfileSettings>;
};

export type ProfileMetadata = {
  __typename?: "ProfileMetadata";
  addressCountryOptions: Array<ListChoice>;
  addressStateOptions: Array<AddressStateOption>;
  phoneCodeOptions: Array<ListChoice>;
  phoneTypeOptions: Array<ListChoice>;
  salutationOptions: Array<ListChoice>;
};

export type ProfilePreferences = {
  __typename?: "ProfilePreferences";
  additionalNotes?: Maybe<Scalars["String"]["output"]>;
  assistantEmail?: Maybe<Scalars["String"]["output"]>;
  assistantName?: Maybe<Scalars["String"]["output"]>;
  dietaryRestrictions?: Maybe<Scalars["String"]["output"]>;
  displayName?: Maybe<Scalars["String"]["output"]>;
  hotelRequests?: Maybe<Scalars["String"]["output"]>;
};

export type ProfileSettings = {
  __typename?: "ProfileSettings";
  emailNotificationsEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  eventRemindersEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  messagesFromStaffEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  pushNotificationsEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  smsNotificationsEnabled?: Maybe<Scalars["Boolean"]["output"]>;
  theme?: Maybe<Scalars["String"]["output"]>;
  updatesFromHelpDeskEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type Query = {
  __typename?: "Query";
  /**
   * Approved board observation requests for a given requestor email.
   * Replaces /api/board/conferences-approved-observations.
   */
  approvedObservations: Array<Observation>;
  /**
   * Upcoming conferences for the board portal: every 'Conf Phase 1'
   * (PENDING) conference plus future-dated 'Conf Phase 2' (SCHEDULED)
   * conferences, ordered by start date ascending. Completed and past
   * conferences are excluded.
   *
   * Tier B (@scope): no rule needed. This is a board-wide upcoming-conference
   * roster, not a per-caller participation view — every board:* caller is
   * expected to see the same list (that's the point of the field), and entry to
   * it is already gated by @roles. Under the narrowing-only model, the absence
   * of an @scope rule means OPEN (no row restriction) for those callers.
   */
  boardConferences: Array<Event>;
  checkEligibility?: Maybe<Profile>;
  /** Global, non-user-specific application configuration. */
  config?: Maybe<AppConfig>;
  /**
   * Portal callers (allow) see any requested event ids. Concierge (identityOnly)
   * is restricted to events they participate in. Event *lists* for Concierge use
   * `me.eventsConnection`; this field is still used for event details by id.
   */
  events: Array<Event>;
  getConversation: ConversationMessageConnection;
  getInbox: InboxConnection;
  getInboxItem?: Maybe<InboxItem>;
  getMessage?: Maybe<OneWayMessage>;
  /**
   * Returns conferences that require honoraria review. A conference qualifies when:
   *   * Record_Type = 'Conference' and Status = 'Completed'
   *   * It has at least one Payment_Information row with status 'Incomplete'
   *     whose contact is also a valid CampaignMember on that conference
   *     (role of Conferee / Director / Discussion Leader / Other AND
   *      status of Attended or Registration Completed).
   * Replaces the legacy Apex REST endpoint /honorariumConferences.
   *
   * The details page uses `Query.events(ids: [eNumber])` with the
   * `honorarium { participantsConnection }` selection — no separate
   * detail query is needed.
   *
   * Auditor (allow) sees all qualifying conferences; approver (identityOnly)
   * is restricted to LF Rep events.
   */
  honorariumConferences: Array<Event>;
  /**
   * List LibertyAI conversations for the caller. Pass `ids` to fetch specific
   * conversations; omit to list all of the caller's conversations.
   */
  libertyAIConversations: Array<LibertyAiConversation>;
  me: Person;
  /**
   * The calling board member's conference watchlist — upcoming conferences
   * they flagged interest in ('LF Board Interest'). Identity-scoped;
   * callers with no Salesforce Contact get an empty list.
   */
  myConferenceInterests: Array<ConferenceInterest>;
  /**
   * Board observation requests pending approval, across all conferences or
   * filtered to one by eNumber. Staff review queue — replaces the legacy
   * Next.js routes /api/board/conferences-pending-approval and
   * /api/board/conference-pending-approval. Source of truth for the request
   * itself is Jira (project TCOR/CORT, status "Final Approval"); conference
   * summary/location/dates are enriched from Salesforce.
   */
  pendingObservationApprovals: Array<Observation>;
  people: Array<Person>;
  profile: Profile;
  profileMetadata: ProfileMetadata;
  /**
   * Cross-entity text search over conferences and people, mirroring the
   * portal's Salesforce API_Search Apex endpoint. Each whitespace-separated
   * word in `term` is prefix-matched (word*) and AND-combined; terms shorter
   * than 3 characters return empty results. Conferences matching the terms
   * directly are combined with conferences associated (via CampaignMember)
   * with matching people, sorted by start date descending, and capped at
   * `maxEvents` (default 7). People are capped at `maxPeople` (default 50).
   *
   * No @scope (OPEN for SearchResult's @roles). SearchMapper overrides execute()
   * and does not consult ScopeEnforcer — safe only while this field stays OPEN.
   * Adding a narrowing @scope would require wiring the enforcer into SearchMapper.
   */
  search: SearchResult;
  /**
   * Conference attendees for the Salesforce Canvas iframe. The id is the
   * Salesforce record id. Admitted only for a Canvas JWT; see the authorizer.
   */
  sfCanvasEvent?: Maybe<SfCanvasEvent>;
  sharedEvents: Array<Event>;
  /**
   * Returns a short-lived presigned S3 GET URL for downloading a
   * previously-uploaded tax document PDF. The S3 key convention is
   * `tax/{guid}/{fileFormat}` (lowercased), matching taxFormUploadUrl.
   */
  taxFormDownloadUrl: TaxFormPresignedUrl;
  /**
   * Returns a short-lived S3 presigned POST so the client can upload a tax
   * document PDF directly to `tax/{guid}/{fileFormat}` (lowercased). After
   * the POST succeeds, call uploadTaxDocument to persist the URL on Contact.
   */
  taxFormUploadUrl: TaxFormPresignedPost;
  /**
   * Upcoming (not-yet-completed) conferences requiring tax processing.
   * Replaces the legacy /api/tax-forms/upcoming-conferences REST route.
   * Returns standard Event fields; per-participant tax/compliance data is
   * reached via Event.participantConnection.edges[].accountInfo /
   * .governmentForm / .taxInfo.allPayments. Event.taxVendorPaymentMethods
   * carries the Intacct
   * payment-method lookup for this conference's vendor-linked participants
   * — join it client-side against accountInfo.intacctVendorId.
   */
  taxUpcomingConferences: Array<Event>;
  /**
   * Upcoming (future) board meeting events, earliest first. Drives the
   * "Next Board Meeting" Dashboard card. Returns at most `limit` events
   * (default 10, cap 50).
   */
  upcomingBoardMeetings: Array<BoardMeeting>;
};

export type QueryApprovedObservationsArgs = {
  requestorEmail: Scalars["String"]["input"];
};

export type QueryCheckEligibilityArgs = {
  email: Scalars["String"]["input"];
};

export type QueryEventsArgs = {
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type QueryGetConversationArgs = {
  id: Scalars["ID"]["input"];
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  nextToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetInboxArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  nextToken?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetInboxItemArgs = {
  id: Scalars["ID"]["input"];
};

export type QueryGetMessageArgs = {
  messageId: Scalars["ID"]["input"];
};

export type QueryLibertyAiConversationsArgs = {
  ids?: InputMaybe<Array<Scalars["ID"]["input"]>>;
};

export type QueryPendingObservationApprovalsArgs = {
  eNumber?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryPeopleArgs = {
  ids: Array<Scalars["ID"]["input"]>;
};

export type QuerySearchArgs = {
  maxEvents?: InputMaybe<Scalars["Int"]["input"]>;
  maxPeople?: InputMaybe<Scalars["Int"]["input"]>;
  term: Scalars["String"]["input"];
};

export type QuerySfCanvasEventArgs = {
  id: Scalars["ID"]["input"];
};

export type QuerySharedEventsArgs = {
  participantId: Scalars["ID"]["input"];
};

export type QueryTaxFormDownloadUrlArgs = {
  fileFormat: TaxDocumentFormat;
  guid: Scalars["String"]["input"];
};

export type QueryTaxFormUploadUrlArgs = {
  fileFormat: TaxDocumentFormat;
  guid: Scalars["String"]["input"];
};

export type QueryUpcomingBoardMeetingsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type Reading = Node & {
  __typename?: "Reading";
  citation?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
};

export type Referral = Node & {
  __typename?: "Referral";
  affiliation: Scalars["String"]["output"];
  expertise?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  isPersonalContact?: Maybe<Scalars["Boolean"]["output"]>;
  name: Scalars["String"]["output"];
  origin?: Maybe<Scalars["String"]["output"]>;
  reason: Scalars["String"]["output"];
  willContact?: Maybe<Scalars["Boolean"]["output"]>;
};

export type RegisterDeviceTokenInput = {
  deviceName?: InputMaybe<Scalars["String"]["input"]>;
  platform: DeviceTokenPlatform;
  token: Scalars["String"]["input"];
};

export type RegisterDeviceTokenResult = {
  __typename?: "RegisterDeviceTokenResult";
  success: Scalars["Boolean"]["output"];
};

export type RemoveConferenceInterestResult = {
  __typename?: "RemoveConferenceInterestResult";
  eNumber: Scalars["String"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type RequestAddressChangeInput = {
  city?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  postalCode?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
  street?: InputMaybe<Scalars["String"]["input"]>;
};

export type RolePaymentStatusInput = {
  /** 'Yes' or 'No' — translated server-side to the Payment_Status__c picklist values ('Paid'/'Unpaid'). */
  paymentStatus: Scalars["String"]["input"];
  role: Scalars["String"]["input"];
};

export type SfCanvasAttendeeConnection = {
  __typename?: "SFCanvasAttendeeConnection";
  edges: Array<SfCanvasAttendeeEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type SfCanvasAttendeeEdge = {
  __typename?: "SFCanvasAttendeeEdge";
  cursor: Scalars["String"]["output"];
  invitationStatus?: Maybe<Scalars["String"]["output"]>;
  node?: Maybe<SfCanvasPerson>;
  roles: Array<Scalars["String"]["output"]>;
  status?: Maybe<Scalars["String"]["output"]>;
};

/**
 * Conference attendees for the Salesforce Canvas iframe.
 *
 * These types carry no @roles. The Lambda authorizer admits them only for a
 * Canvas JWT, and denies every other field on that credential. An Auth0 token
 * is rejected for Query.sfCanvasEvent.
 */
export type SfCanvasEvent = Node & {
  __typename?: "SFCanvasEvent";
  attendeeConnection?: Maybe<SfCanvasAttendeeConnection>;
  eNumber: Scalars["String"]["output"];
  endDate?: Maybe<Scalars["String"]["output"]>;
  hotelName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  location?: Maybe<Scalars["String"]["output"]>;
  sessions: Array<SfCanvasSession>;
  startDate?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type SfCanvasPerson = Node & {
  __typename?: "SFCanvasPerson";
  id: Scalars["ID"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  primaryAffiliation?: Maybe<Scalars["String"]["output"]>;
};

export type SfCanvasReading = {
  __typename?: "SFCanvasReading";
  citation?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  sortOrder?: Maybe<Scalars["Int"]["output"]>;
};

export type SfCanvasSession = Node & {
  __typename?: "SFCanvasSession";
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  endTime?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  optional?: Maybe<Scalars["Boolean"]["output"]>;
  readings: Array<SfCanvasReading>;
  sessionNumber?: Maybe<Scalars["String"]["output"]>;
  startTime?: Maybe<Scalars["String"]["output"]>;
  subtitle?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type SearchResult = {
  __typename?: "SearchResult";
  events: Array<Event>;
  people: Array<Person>;
};

export type SendConversationMessageInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  body: Scalars["String"]["input"];
  conversationId: Scalars["ID"]["input"];
};

export type SendMessageResult = {
  __typename?: "SendMessageResult";
  messageId: Scalars["ID"]["output"];
  success: Scalars["Boolean"]["output"];
};

export type SendOneWayMessageInput = {
  attachments?: InputMaybe<Array<AttachmentInput>>;
  body: Scalars["String"]["input"];
  broadcastToAllParticipants?: InputMaybe<Scalars["Boolean"]["input"]>;
  event: Scalars["String"]["input"];
  priority?: InputMaybe<MessagePriority>;
  recipientIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
  senderTitle?: InputMaybe<Scalars["String"]["input"]>;
  subject: Scalars["String"]["input"];
};

export type Session = Node & {
  __typename?: "Session";
  calendarDate?: Maybe<Scalars["String"]["output"]>;
  endTime?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  notes?: Maybe<Scalars["String"]["output"]>;
  optional?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * Tier B (@scope): no rule needed. Reader-list visibility is gated by the
   * grandparent Campaign's Reader_Available__c publication flag
   * (SessionReadingMapper.applyFilters), with board roles bypassing it to review
   * pre-publication — the same orthogonal-gate reasoning as
   * Event.participantConnection/sessionsConnection applies. Under the
   * narrowing-only model, no @scope rule → OPEN for its admitted callers.
   */
  readingsConnection?: Maybe<SessionReadingConnection>;
  sessionNumber?: Maybe<Scalars["String"]["output"]>;
  startTime?: Maybe<Scalars["String"]["output"]>;
  subtitle?: Maybe<Scalars["String"]["output"]>;
  title?: Maybe<Scalars["String"]["output"]>;
};

export type SessionReadingConnection = {
  __typename?: "SessionReadingConnection";
  edges: Array<SessionReadingEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type SessionReadingEdge = {
  __typename?: "SessionReadingEdge";
  cursor: Scalars["String"]["output"];
  node: Reading;
};

/**
 * A fiscal-year strategy-category tier assignment for a person
 * (StrategyCategoryTier__c).
 */
export type StrategicCategory = {
  __typename?: "StrategicCategory";
  /** Strategy category name (StrategyCategory__r.Name), e.g. "Conference". */
  category?: Maybe<Scalars["String"]["output"]>;
  fiscalYear?: Maybe<Scalars["String"]["output"]>;
  tier?: Maybe<Scalars["String"]["output"]>;
};

export type SubmitHonorariumConfereeInput = {
  guid: Scalars["String"]["input"];
  /** Roles the LF Rep authorized for payment (an Intacct bill line is created for each). */
  paidRoles: Array<Scalars["String"]["input"]>;
  /**
   * The Rep's reason for the unpaid roles (the conferee's reviewer notes).
   * Shown alongside unpaidRoles; one reason per conferee, max 2000 characters.
   */
  unpaidReason?: InputMaybe<Scalars["String"]["input"]>;
  /**
   * Roles the LF Rep marked "No" (not authorized for payment). Never billed;
   * listed under "Not authorized for payment" in the Accounting email, Slack
   * message and PDF. Optional so existing clients keep working.
   */
  unpaidRoles?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type SubmitHonorariumResult = {
  __typename?: "SubmitHonorariumResult";
  /** Text to show the user: the submission was received and they will be notified once payments are processed. */
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type Subscription = {
  __typename?: "Subscription";
  /**
   * Subscribe to LibertyAI notifications for a specific user — mirrors
   * onUserNotification. Requires portal:liberty-ai:* (enforced via
   * LibertyAINotification's type-level @roles, same fallback mechanism as
   * onUserNotification/UserNotification). Delivers the agent's processing
   * state (IDLE/WORKING/ERROR) as it works; when a new message is actually
   * ready, fetch it via libertyAIConversations.
   */
  onLibertyAINotification?: Maybe<LibertyAiNotification>;
  onUserNotification?: Maybe<UserNotification>;
};

export type SubscriptionOnLibertyAiNotificationArgs = {
  userId: Scalars["ID"]["input"];
};

export type SubscriptionOnUserNotificationArgs = {
  userId: Scalars["ID"]["input"];
};

export enum TaxDocumentFormat {
  W8 = "W8",
  W9 = "W9",
  X8233 = "X8233",
}

/**
 * A Payment_Information__c row for the Tax Forms fee panel. Same Salesforce
 * shape as HonorariumPayment, but a distinct GraphQL type so the authorizer
 * does not inherit HonorariumPayment's honorarium-only @roles — Tax Forms
 * must be able to read full fee history (`ParticipantTaxInfo.allPayments`)
 * without holding an honorarium role. Honorarium reviewers keep using the
 * Incomplete-only `payments` field.
 */
export type TaxFormPayment = {
  __typename?: "TaxFormPayment";
  fee?: Maybe<Scalars["Float"]["output"]>;
  id: Scalars["ID"]["output"];
  participantType?: Maybe<Scalars["String"]["output"]>;
  paymentDeclined?: Maybe<Scalars["Boolean"]["output"]>;
  paymentNote?: Maybe<Scalars["String"]["output"]>;
  paymentStatus?: Maybe<Scalars["String"]["output"]>;
  programName?: Maybe<Scalars["String"]["output"]>;
  taxWithholdingPercentage?: Maybe<Scalars["Float"]["output"]>;
};

export type TaxFormPresignedPost = {
  __typename?: "TaxFormPresignedPost";
  /** ISO-8601 timestamp when the presigned POST expires. */
  expiresAt: Scalars["String"]["output"];
  /** Form fields that must be appended before the file (policy, signature, Content-Type, key). */
  fields: Scalars["AWSJSON"]["output"];
  /** Maximum accepted PDF size in bytes (enforced by the S3 POST policy). */
  maxSize: Scalars["Int"]["output"];
  /** S3 bucket URL to POST the multipart form to. */
  url: Scalars["String"]["output"];
};

export type TaxFormPresignedUrl = {
  __typename?: "TaxFormPresignedUrl";
  /** ISO-8601 timestamp when the presigned URL expires. */
  expiresAt: Scalars["String"]["output"];
  /** Short-lived presigned GET URL for the tax document PDF in S3. */
  url: Scalars["String"]["output"];
};

export type TaxVendorPaymentMethod = {
  __typename?: "TaxVendorPaymentMethod";
  paymentMethod?: Maybe<Scalars["String"]["output"]>;
  vendorId: Scalars["String"]["output"];
};

export type TravelInfo = {
  __typename?: "TravelInfo";
  estimatedArrivalDate?: Maybe<Scalars["String"]["output"]>;
  estimatedArrivalTime?: Maybe<Scalars["String"]["output"]>;
  flightNumber?: Maybe<Scalars["String"]["output"]>;
  methodOfTravel?: Maybe<TravelMethod>;
  otherTravelMethodExplanation?: Maybe<Scalars["String"]["output"]>;
  plannedDepartureDate?: Maybe<Scalars["String"]["output"]>;
};

export enum TravelMethod {
  Driving = "DRIVING",
  Flying = "FLYING",
  Other = "OTHER",
}

/**
 * Same shape as EventParticipantConnection but a distinct type on
 * purpose: the Lambda Authorizer's permission grammar is
 * `read:{returnType}`, so a separate type is what lets
 * `Event.unconfirmedParticipantConnection` be denied independently
 * of the confirmed connection. Edges are shared — the per-edge data
 * is identical; only who may see the list differs.
 *
 * Matches the board conference-detail UI: approver and requestor only
 * (not portal:board:viewer or portal:people:*).
 */
export type UnconfirmedParticipantConnection = {
  __typename?: "UnconfirmedParticipantConnection";
  edges: Array<EventParticipantEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type UpdateConfereeTaxDetailsInput = {
  eNumber: Scalars["String"]["input"];
  financeNotes?: InputMaybe<Scalars["String"]["input"]>;
  governmentOfficial?: InputMaybe<Scalars["String"]["input"]>;
  guid: Scalars["String"]["input"];
  intacctVendorId?: InputMaybe<Scalars["String"]["input"]>;
  paymentEligible?: InputMaybe<Scalars["String"]["input"]>;
  paymentUpdates?: InputMaybe<Array<PaymentTaxWithholdingInput>>;
  workVisa?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateHonorariumNotesResult = {
  __typename?: "UpdateHonorariumNotesResult";
  success: Scalars["Boolean"]["output"];
};

export type UpdateHonorariumPaymentStatusResult = {
  __typename?: "UpdateHonorariumPaymentStatusResult";
  success: Scalars["Boolean"]["output"];
};

export type UpdatePersonalInfoInput = {
  correspondenceEmail?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  middleName?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  phoneType?: InputMaybe<Scalars["String"]["input"]>;
  proposedAffiliationName?: InputMaybe<Scalars["String"]["input"]>;
  proposedAffiliationTitle?: InputMaybe<Scalars["String"]["input"]>;
  publicBio?: InputMaybe<Scalars["String"]["input"]>;
  publicEmail?: InputMaybe<Scalars["String"]["input"]>;
  salutation?: InputMaybe<Scalars["String"]["input"]>;
  suffix?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdatePreferencesInput = {
  additionalNotes?: InputMaybe<Scalars["String"]["input"]>;
  assistantEmail?: InputMaybe<Scalars["String"]["input"]>;
  assistantName?: InputMaybe<Scalars["String"]["input"]>;
  dietaryRestrictions?: InputMaybe<Scalars["String"]["input"]>;
  displayName?: InputMaybe<Scalars["String"]["input"]>;
  hotelRequests?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateProgramMaterialsAddressInput = {
  city?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  eNumber: Scalars["String"]["input"];
  postalCode?: InputMaybe<Scalars["String"]["input"]>;
  state?: InputMaybe<Scalars["String"]["input"]>;
  street?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateResult = {
  __typename?: "UpdateResult";
  /** User-facing status for a failed update (e.g. duplicate Vendor ID). Null on success. */
  message?: Maybe<Scalars["String"]["output"]>;
  success: Scalars["Boolean"]["output"];
};

export type UpdateSettingsInput = {
  emailNotificationsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  eventRemindersEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  messagesFromStaffEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  pushNotificationsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  smsNotificationsEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
  theme?: InputMaybe<Scalars["String"]["input"]>;
  updatesFromHelpDeskEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpdateTravelInfoInput = {
  estimatedArrivalDate?: InputMaybe<Scalars["String"]["input"]>;
  estimatedArrivalTime?: InputMaybe<Scalars["String"]["input"]>;
  eventId: Scalars["ID"]["input"];
  flightNumber?: InputMaybe<Scalars["String"]["input"]>;
  methodOfTravel?: InputMaybe<TravelMethod>;
  otherTravelMethodExplanation?: InputMaybe<Scalars["String"]["input"]>;
  plannedDepartureDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type UploadTaxDocumentInput = {
  fileFormat: TaxDocumentFormat;
  guid: Scalars["String"]["input"];
  /** ISO date string. Ignored for W9 (no expiry, matches legacy behavior). */
  validUntil?: InputMaybe<Scalars["String"]["input"]>;
};

export type UserNotification = {
  __typename?: "UserNotification";
  timestamp: Scalars["String"]["output"];
  userId: Scalars["ID"]["output"];
};

export type Venue = Node & {
  __typename?: "Venue";
  address: Address;
  displayAddress?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["ID"]["output"];
  imageUrl?: Maybe<Scalars["String"]["output"]>;
  /** Geocoded hotel billing address (Account.BillingLatitude/BillingLongitude). Null until Salesforce has geocoded it. */
  location?: Maybe<GeoPoint>;
  name?: Maybe<Scalars["String"]["output"]>;
  phoneNumber?: Maybe<Scalars["String"]["output"]>;
  url?: Maybe<Scalars["String"]["output"]>;
};

export type BoardConferencesQueryVariables = Exact<{ [key: string]: never }>;

export type BoardConferencesQuery = {
  __typename?: "Query";
  boardConferences: Array<{
    __typename?: "Event";
    eNumber: string;
    title: string;
    status?: EventStatus | null;
    startDate?: string | null;
    endDate?: string | null;
    region?: string | null;
    subRegion?: string | null;
    projectedQuarter?: string | null;
    fiscalYear?: string | null;
    directorDisplay?: string | null;
    representative?: { __typename?: "Person"; name?: string | null } | null;
    venue?: {
      __typename?: "Venue";
      address: {
        __typename?: "Address";
        city?: string | null;
        stateProvinceRegion?: string | null;
        country?: string | null;
      };
    } | null;
    participantConnection?: {
      __typename?: "EventParticipantConnection";
      edges: Array<{ __typename?: "EventParticipantEdge"; cursor: string }>;
    } | null;
  }>;
};

export type BoardConferenceDetailsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>;
}>;

export type BoardConferenceDetailsQuery = {
  __typename?: "Query";
  events: Array<{
    __typename?: "Event";
    eNumber: string;
    title: string;
    status?: EventStatus | null;
    startDate?: string | null;
    endDate?: string | null;
    region?: string | null;
    projectedQuarter?: string | null;
    fiscalYear?: string | null;
    totalBudget?: number | null;
    boardDocumentUrl?: string | null;
    readersLink?: string | null;
    representative?: { __typename?: "Person"; name?: string | null } | null;
    planner?: { __typename?: "Person"; name?: string | null } | null;
    venue?: {
      __typename?: "Venue";
      name?: string | null;
      displayAddress?: string | null;
      phoneNumber?: string | null;
      url?: string | null;
      address: {
        __typename?: "Address";
        city?: string | null;
        stateProvinceRegion?: string | null;
        country?: string | null;
      };
    } | null;
    participantConnection?: {
      __typename?: "EventParticipantConnection";
      edges: Array<{
        __typename?: "EventParticipantEdge";
        status: ParticipantStatus;
        invitationStatus?: string | null;
        roles: Array<ParticipantRole>;
        otherRole?: string | null;
        node?: {
          __typename?: "Person";
          id: string;
          name?: string | null;
          description?: string | null;
          conferencesAttendedCount?: number | null;
          primaryAffiliation?: string | null;
        } | null;
      }>;
    } | null;
  }>;
};

export type BoardConferenceUnconfirmedParticipantsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>;
}>;

export type BoardConferenceUnconfirmedParticipantsQuery = {
  __typename?: "Query";
  events: Array<{
    __typename?: "Event";
    eNumber: string;
    unconfirmedParticipantConnection?: {
      __typename?: "UnconfirmedParticipantConnection";
      edges: Array<{
        __typename?: "EventParticipantEdge";
        status: ParticipantStatus;
        invitationStatus?: string | null;
        roles: Array<ParticipantRole>;
        otherRole?: string | null;
        node?: {
          __typename?: "Person";
          id: string;
          name?: string | null;
          description?: string | null;
          conferencesAttendedCount?: number | null;
          primaryAffiliation?: string | null;
        } | null;
      }>;
    } | null;
  }>;
};

export type ConferenceReadingsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>;
}>;

export type ConferenceReadingsQuery = {
  __typename?: "Query";
  events: Array<{
    __typename?: "Event";
    sessionsConnection?: {
      __typename?: "EventSessionConnection";
      edges: Array<{
        __typename?: "EventSessionEdge";
        node?: {
          __typename?: "Session";
          title?: string | null;
          readingsConnection?: {
            __typename?: "SessionReadingConnection";
            edges: Array<{
              __typename?: "SessionReadingEdge";
              node: { __typename?: "Reading"; citation?: string | null };
            }>;
          } | null;
        } | null;
      }>;
    } | null;
  }>;
};

export type MyConferenceInterestsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type MyConferenceInterestsQuery = {
  __typename?: "Query";
  myConferenceInterests: Array<{
    __typename?: "ConferenceInterest";
    id: string;
    eNumber: string;
    title?: string | null;
  }>;
};

export type AddConferenceInterestMutationVariables = Exact<{
  eNumber: Scalars["String"]["input"];
}>;

export type AddConferenceInterestMutation = {
  __typename?: "Mutation";
  addConferenceInterest: {
    __typename?: "ConferenceInterest";
    id: string;
    eNumber: string;
    title?: string | null;
  };
};

export type RemoveConferenceInterestMutationVariables = Exact<{
  eNumber: Scalars["String"]["input"];
}>;

export type RemoveConferenceInterestMutation = {
  __typename?: "Mutation";
  removeConferenceInterest: {
    __typename?: "RemoveConferenceInterestResult";
    success: boolean;
    eNumber: string;
  };
};

export type UpcomingBoardMeetingsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type UpcomingBoardMeetingsQuery = {
  __typename?: "Query";
  upcomingBoardMeetings: Array<{
    __typename?: "BoardMeeting";
    id: string;
    title: string;
    startDate: string;
    endDate?: string | null;
  }>;
};

export type SubmitHonorariumMutationVariables = Exact<{
  conferenceId: Scalars["String"]["input"];
  documentId?: InputMaybe<Scalars["String"]["input"]>;
  conferees:
    Array<SubmitHonorariumConfereeInput> | SubmitHonorariumConfereeInput;
}>;

export type SubmitHonorariumMutation = {
  __typename?: "Mutation";
  submitHonorarium: {
    __typename?: "SubmitHonorariumResult";
    success: boolean;
    message?: string | null;
  };
};

export type HonorariumConferencesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type HonorariumConferencesQuery = {
  __typename?: "Query";
  honorariumConferences: Array<{
    __typename?: "Event";
    id: string;
    eNumber: string;
    title: string;
    shortTitle?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    region?: string | null;
    directorDisplay?: string | null;
    representative?: { __typename?: "Person"; name?: string | null } | null;
    venue?: {
      __typename?: "Venue";
      address: {
        __typename?: "Address";
        city?: string | null;
        stateProvinceRegion?: string | null;
        country?: string | null;
      };
    } | null;
    honorarium?: {
      __typename?: "EventHonorarium";
      incompletePaymentCount?: number | null;
    } | null;
  }>;
};

export type HonorariumConferenceDetailsQueryVariables = Exact<{
  eNumber: Scalars["ID"]["input"];
}>;

export type HonorariumConferenceDetailsQuery = {
  __typename?: "Query";
  events: Array<{
    __typename?: "Event";
    id: string;
    eNumber: string;
    title: string;
    shortTitle?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    region?: string | null;
    directorDisplay?: string | null;
    representative?: { __typename?: "Person"; name?: string | null } | null;
    planner?: { __typename?: "Person"; name?: string | null } | null;
    venue?: {
      __typename?: "Venue";
      name?: string | null;
      address: {
        __typename?: "Address";
        city?: string | null;
        stateProvinceRegion?: string | null;
        country?: string | null;
      };
    } | null;
    honorarium?: {
      __typename?: "EventHonorarium";
      incompletePaymentCount?: number | null;
      participantsConnection?: {
        __typename?: "EventParticipantConnection";
        edges: Array<{
          __typename?: "EventParticipantEdge";
          roles: Array<ParticipantRole>;
          otherRole?: string | null;
          status: ParticipantStatus;
          node?: {
            __typename?: "Person";
            id: string;
            name?: string | null;
          } | null;
          honorariaInfo?: {
            __typename?: "ParticipantHonorariaInfo";
            honorariaNotes?: string | null;
            payments: Array<{
              __typename?: "HonorariumPayment";
              id: string;
              programName?: string | null;
              fee?: number | null;
              taxWithholdingPercentage?: number | null;
              paymentDeclined?: boolean | null;
              paymentStatus?: string | null;
              participantType?: string | null;
              paymentNote?: string | null;
            }>;
          } | null;
          accountInfo?: {
            __typename?: "ParticipantAccountInfo";
            intacctVendorId?: string | null;
            paymentEligible?: boolean | null;
            workVisa?: boolean | null;
            governmentPosition?: boolean | null;
            government?: boolean | null;
          } | null;
        }>;
      } | null;
    } | null;
  }>;
};

export type UpdateHonorariumNotesMutationVariables = Exact<{
  eNumber: Scalars["String"]["input"];
  notes: Array<ConfereeNoteInput> | ConfereeNoteInput;
}>;

export type UpdateHonorariumNotesMutation = {
  __typename?: "Mutation";
  updateHonorariumNotes: {
    __typename?: "UpdateHonorariumNotesResult";
    success: boolean;
  };
};

export type LibertyAiConversationsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"]>;
}>;

export type LibertyAiConversationsQuery = {
  __typename?: "Query";
  libertyAIConversations: Array<{
    __typename?: "LibertyAIConversation";
    id: string;
    createdAt: string;
    updatedAt: string;
    state: LibertyAiAgentState;
    statusMessage?: string | null;
    name?: string | null;
    lastReadAt?: string | null;
    messagesConnection: {
      __typename?: "LibertyAIMessageConnection";
      edges: Array<{
        __typename?: "LibertyAIMessageEdge";
        cursor: string;
        node: {
          __typename?: "LibertyAIMessage";
          id: string;
          conversationId: string;
          role: LibertyAiMessageRole;
          text?: string | null;
          blocks?: any | null;
          timestamp: string;
        };
      }>;
      pageInfo?: {
        __typename?: "PageInfo";
        hasNextPage: boolean;
        hasPreviousPage: boolean;
      } | null;
    };
  }>;
};

export type LibertyAiConversationSummariesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type LibertyAiConversationSummariesQuery = {
  __typename?: "Query";
  libertyAIConversations: Array<{
    __typename?: "LibertyAIConversation";
    id: string;
    createdAt: string;
    updatedAt: string;
    state: LibertyAiAgentState;
    statusMessage?: string | null;
    name?: string | null;
  }>;
};

export type SendLibertyAiMessageMutationVariables = Exact<{
  message: Scalars["String"]["input"];
  conversationId?: InputMaybe<Scalars["ID"]["input"]>;
}>;

export type SendLibertyAiMessageMutation = {
  __typename?: "Mutation";
  sendLibertyAIMessage: {
    __typename?: "LibertyAIMessageResult";
    conversationId: string;
  };
};

export type DeleteLibertyAiConversationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
}>;

export type DeleteLibertyAiConversationMutation = {
  __typename?: "Mutation";
  deleteLibertyAIConversation: boolean;
};

export type RenameLibertyAiConversationMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  name: Scalars["String"]["input"];
}>;

export type RenameLibertyAiConversationMutation = {
  __typename?: "Mutation";
  renameLibertyAIConversation: {
    __typename?: "LibertyAIConversation";
    id: string;
    name?: string | null;
  };
};

export type SetLibertyAiConversationReadStateMutationVariables = Exact<{
  id: Scalars["ID"]["input"];
  read: Scalars["Boolean"]["input"];
}>;

export type SetLibertyAiConversationReadStateMutation = {
  __typename?: "Mutation";
  setLibertyAIConversationReadState: {
    __typename?: "LibertyAIConversation";
    id: string;
    lastReadAt?: string | null;
  };
};

export type OnLibertyAiNotificationSubscriptionVariables = Exact<{
  userId: Scalars["ID"]["input"];
}>;

export type OnLibertyAiNotificationSubscription = {
  __typename?: "Subscription";
  onLibertyAINotification?: {
    __typename?: "LibertyAINotification";
    userId: string;
    conversationId: string;
    state: LibertyAiAgentState;
    statusMessage?: string | null;
    timestamp: string;
  } | null;
};

export type LibertyAiMeQueryVariables = Exact<{ [key: string]: never }>;

export type LibertyAiMeQuery = {
  __typename?: "Query";
  me: { __typename?: "Person"; id: string };
};

export type PendingObservationApprovalsQueryVariables = Exact<{
  eNumber?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type PendingObservationApprovalsQuery = {
  __typename?: "Query";
  pendingObservationApprovals: Array<{
    __typename?: "Observation";
    id: string;
    conferenceId?: string | null;
    summary?: string | null;
    location?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    requestorName?: string | null;
    requestorEmail?: string | null;
  }>;
};

export type ApprovedObservationsQueryVariables = Exact<{
  requestorEmail: Scalars["String"]["input"];
}>;

export type ApprovedObservationsQuery = {
  __typename?: "Query";
  approvedObservations: Array<{
    __typename?: "Observation";
    id: string;
    conferenceId?: string | null;
    summary?: string | null;
    location?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    requestorName?: string | null;
    requestorEmail?: string | null;
  }>;
};

export type CreateObservationRequestMutationVariables = Exact<{
  input: CreateObservationInput;
}>;

export type CreateObservationRequestMutation = {
  __typename?: "Mutation";
  createObservationRequest: {
    __typename?: "Observation";
    id: string;
    conferenceId?: string | null;
    summary?: string | null;
  };
};

export type ApproveObservationsMutationVariables = Exact<{
  issueKeys: Array<Scalars["String"]["input"]> | Scalars["String"]["input"];
}>;

export type ApproveObservationsMutation = {
  __typename?: "Mutation";
  approveObservations: {
    __typename?: "ApproveObservationsResult";
    results: Array<{
      __typename?: "ApproveObservationResult";
      issueKey: string;
      success: boolean;
      message?: string | null;
    }>;
  };
};

export type PersonDetailsQueryVariables = Exact<{
  ids: Array<Scalars["ID"]["input"]> | Scalars["ID"]["input"];
}>;

export type PersonDetailsQuery = {
  __typename?: "Query";
  people: Array<{
    __typename?: "Person";
    id: string;
    name?: string | null;
    title?: string | null;
    description?: string | null;
    primaryAffiliation?: string | null;
    primaryExpertise?: string | null;
    personType?: string | null;
    imageUrl?: string | null;
    correspondenceEmail?: string | null;
    phone?: string | null;
    websiteUrl?: string | null;
    mailingStreet?: string | null;
    mailingCity?: string | null;
    mailingState?: string | null;
    mailingPostalCode?: string | null;
    mailingCountry?: string | null;
    mostRecentAttendedDate?: string | null;
    attendedConferencesOnlyCount?: number | null;
    attendedAsDirectorCount?: number | null;
    attendedAsDiscussionLeadCount?: number | null;
    strategicCategories?: Array<{
      __typename?: "StrategicCategory";
      fiscalYear?: string | null;
      category?: string | null;
      tier?: string | null;
    }> | null;
    eventsConnection?: {
      __typename?: "PersonEventConnection";
      edges: Array<{
        __typename?: "PersonEventEdge";
        roles: Array<ParticipantRole>;
        otherRole?: string | null;
        status: ParticipantStatus;
        invitationStatus?: string | null;
        node: {
          __typename?: "Event";
          eNumber: string;
          title: string;
          startDate?: string | null;
          endDate?: string | null;
          region?: string | null;
          status?: EventStatus | null;
          venue?: {
            __typename?: "Venue";
            address: {
              __typename?: "Address";
              city?: string | null;
              stateProvinceRegion?: string | null;
              country?: string | null;
            };
          } | null;
        };
      }>;
    } | null;
  }>;
};

export type CreateReferralMutationVariables = Exact<{
  input: CreateReferralInput;
}>;

export type CreateReferralMutation = {
  __typename?: "Mutation";
  createReferral: {
    __typename?: "Referral";
    name: string;
    affiliation: string;
    reason: string;
    expertise?: string | null;
    origin?: string | null;
    isPersonalContact?: boolean | null;
    willContact?: boolean | null;
  };
};

export type SearchQueryVariables = Exact<{
  term: Scalars["String"]["input"];
}>;

export type SearchQuery = {
  __typename?: "Query";
  search: {
    __typename?: "SearchResult";
    people: Array<{
      __typename?: "Person";
      id: string;
      name?: string | null;
      correspondenceEmail?: string | null;
      phone?: string | null;
      imageUrl?: string | null;
      primaryAffiliation?: string | null;
    }>;
    events: Array<{
      __typename?: "Event";
      eNumber: string;
      title: string;
      startDate?: string | null;
      endDate?: string | null;
      directorDisplay?: string | null;
      region?: string | null;
      representative?: { __typename?: "Person"; name?: string | null } | null;
      venue?: {
        __typename?: "Venue";
        address: {
          __typename?: "Address";
          city?: string | null;
          stateProvinceRegion?: string | null;
          country?: string | null;
        };
      } | null;
    }>;
  };
};

export type TaxUpcomingConferencesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TaxUpcomingConferencesQuery = {
  __typename?: "Query";
  taxUpcomingConferences: Array<{
    __typename?: "Event";
    id: string;
    eNumber: string;
    title: string;
    shortTitle?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    region?: string | null;
    status?: EventStatus | null;
    directorDisplay?: string | null;
    representative?: { __typename?: "Person"; name?: string | null } | null;
    planner?: { __typename?: "Person"; name?: string | null } | null;
    venue?: {
      __typename?: "Venue";
      address: {
        __typename?: "Address";
        city?: string | null;
        stateProvinceRegion?: string | null;
        country?: string | null;
      };
    } | null;
  }>;
};

export type TaxUpcomingConferenceParticipantsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TaxUpcomingConferenceParticipantsQuery = {
  __typename?: "Query";
  taxUpcomingConferences: Array<{
    __typename?: "Event";
    id: string;
    eNumber: string;
    taxVendorPaymentMethods: Array<{
      __typename?: "TaxVendorPaymentMethod";
      vendorId: string;
      paymentMethod?: string | null;
    }>;
    participantConnection?: {
      __typename?: "EventParticipantConnection";
      edges: Array<{
        __typename?: "EventParticipantEdge";
        roles: Array<ParticipantRole>;
        otherRole?: string | null;
        status: ParticipantStatus;
        node?: {
          __typename?: "Person";
          id: string;
          name?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          email?: string | null;
          assistantName?: string | null;
          assistantEmail?: string | null;
        } | null;
        taxInfo?: {
          __typename?: "ParticipantTaxInfo";
          needsTaxAuditAttention?: boolean | null;
          modifiedFields?: string | null;
          allPayments: Array<{
            __typename?: "TaxFormPayment";
            id: string;
            fee?: number | null;
            taxWithholdingPercentage?: number | null;
            paymentDeclined?: boolean | null;
            paymentNote?: string | null;
            participantType?: string | null;
          }>;
        } | null;
        accountInfo?: {
          __typename?: "ParticipantAccountInfo";
          intacctVendorId?: string | null;
          paymentEligible?: boolean | null;
          workVisa?: boolean | null;
          governmentPosition?: boolean | null;
          government?: boolean | null;
          ssnItin?: string | null;
          financeAppNotes?: string | null;
          usGovPosition?: boolean | null;
          usCitizen?: boolean | null;
          paymentEligibleUpdatedDate?: string | null;
          w8DocumentUrl?: string | null;
          w8ValidUntil?: string | null;
          w9DocumentUrl?: string | null;
          w9Status?: string | null;
          x8233DocumentUrl?: string | null;
          x8233ValidUntil?: string | null;
        } | null;
        governmentForm?: {
          __typename?: "ParticipantGovernmentForm";
          citizenshipResidence?: string | null;
          countryOfResidenceTaxPurpose?: string | null;
        } | null;
      }>;
    } | null;
  }>;
};

export type ConferenceRegistrationQueryVariables = Exact<{
  eNumber: Scalars["ID"]["input"];
}>;

export type ConferenceRegistrationQuery = {
  __typename?: "Query";
  events: Array<{
    __typename?: "Event";
    id: string;
    eNumber: string;
    title: string;
    startDate?: string | null;
    endDate?: string | null;
    participantConnection?: {
      __typename?: "EventParticipantConnection";
      edges: Array<{
        __typename?: "EventParticipantEdge";
        roles: Array<ParticipantRole>;
        otherRole?: string | null;
        status: ParticipantStatus;
        invitationStatus?: string | null;
        node?: {
          __typename?: "Person";
          id: string;
          name?: string | null;
          firstName?: string | null;
          middleName?: string | null;
          lastName?: string | null;
          email?: string | null;
          phone?: string | null;
          phoneType?: string | null;
          mailingStreet?: string | null;
          mailingCity?: string | null;
          mailingState?: string | null;
          mailingPostalCode?: string | null;
          mailingCountry?: string | null;
          primaryAffiliation?: string | null;
          primaryAffiliationTitle?: string | null;
        } | null;
        taxInfo?: {
          __typename?: "ParticipantTaxInfo";
          modifiedFields?: string | null;
        } | null;
        accountInfo?: {
          __typename?: "ParticipantAccountInfo";
          workVisa?: boolean | null;
          governmentPosition?: boolean | null;
          government?: boolean | null;
          ssnItin?: string | null;
          usCitizen?: boolean | null;
          usGovPosition?: boolean | null;
          financeAppNotes?: string | null;
        } | null;
        governmentForm?: {
          __typename?: "ParticipantGovernmentForm";
          positionHeld?: string | null;
          electiveOfficeUS?: boolean | null;
          presidentialAppointment?: boolean | null;
          publicOfficeAboveOrEq20k?: boolean | null;
          congressEmployeeAboveOrEq15k?: boolean | null;
          armedForcesPosition?: boolean | null;
          militaryAcademyProfessor?: boolean | null;
          scheduleCPosition?: boolean | null;
          compensationAboveThreshold?: boolean | null;
          assistantToOfficials?: boolean | null;
          irsOversightMember?: boolean | null;
          specialGovEmployee?: boolean | null;
          citizenshipResidence?: string | null;
          countryOfResidenceTaxPurpose?: string | null;
        } | null;
      }>;
    } | null;
  }>;
};

export type UpdateConfereeTaxDetailsMutationVariables = Exact<{
  input: UpdateConfereeTaxDetailsInput;
}>;

export type UpdateConfereeTaxDetailsMutation = {
  __typename?: "Mutation";
  updateConfereeTaxDetails: {
    __typename?: "UpdateResult";
    success: boolean;
    message?: string | null;
  };
};

export type UpdateConfereeNeedsAttentionMutationVariables = Exact<{
  eNumber: Scalars["String"]["input"];
  guid: Scalars["String"]["input"];
  needsAttention: Scalars["Boolean"]["input"];
}>;

export type UpdateConfereeNeedsAttentionMutation = {
  __typename?: "Mutation";
  updateConfereeNeedsAttention: {
    __typename?: "UpdateResult";
    success: boolean;
  };
};

export type UploadTaxDocumentMutationVariables = Exact<{
  input: UploadTaxDocumentInput;
}>;

export type UploadTaxDocumentMutation = {
  __typename?: "Mutation";
  uploadTaxDocument: { __typename?: "UpdateResult"; success: boolean };
};

export type TaxFormUploadUrlQueryVariables = Exact<{
  guid: Scalars["String"]["input"];
  fileFormat: TaxDocumentFormat;
}>;

export type TaxFormUploadUrlQuery = {
  __typename?: "Query";
  taxFormUploadUrl: {
    __typename?: "TaxFormPresignedPost";
    url: string;
    fields: any;
    expiresAt: string;
    maxSize: number;
  };
};

export type TaxFormDownloadUrlQueryVariables = Exact<{
  guid: Scalars["String"]["input"];
  fileFormat: TaxDocumentFormat;
}>;

export type TaxFormDownloadUrlQuery = {
  __typename?: "Query";
  taxFormDownloadUrl: {
    __typename?: "TaxFormPresignedUrl";
    url: string;
    expiresAt: string;
  };
};

export type DeleteTaxDocumentMutationVariables = Exact<{
  guid: Scalars["String"]["input"];
  fileFormat: TaxDocumentFormat;
}>;

export type DeleteTaxDocumentMutation = {
  __typename?: "Mutation";
  deleteTaxDocument: { __typename?: "UpdateResult"; success: boolean };
};

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<
    DocumentTypeDecoration<TResult, TVariables>["__apiType"]
  >;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const BoardConferencesDocument = new TypedDocumentString(`
    query BoardConferences {
  boardConferences {
    eNumber
    title
    status
    startDate
    endDate
    region
    subRegion
    projectedQuarter
    fiscalYear
    directorDisplay
    representative {
      name
    }
    venue {
      address {
        city
        stateProvinceRegion
        country
      }
    }
    participantConnection(types: [BOARD]) {
      edges {
        cursor
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  BoardConferencesQuery,
  BoardConferencesQueryVariables
>;
export const BoardConferenceDetailsDocument = new TypedDocumentString(`
    query BoardConferenceDetails($ids: [ID!]) {
  events(ids: $ids) {
    eNumber
    title
    status
    startDate
    endDate
    region
    projectedQuarter
    fiscalYear
    totalBudget
    boardDocumentUrl
    readersLink
    representative {
      name
    }
    planner {
      name
    }
    venue {
      name
      displayAddress
      phoneNumber
      url
      address {
        city
        stateProvinceRegion
        country
      }
    }
    participantConnection {
      edges {
        status
        invitationStatus
        roles
        otherRole
        node {
          id
          name
          description
          conferencesAttendedCount
          primaryAffiliation
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  BoardConferenceDetailsQuery,
  BoardConferenceDetailsQueryVariables
>;
export const BoardConferenceUnconfirmedParticipantsDocument =
  new TypedDocumentString(`
    query BoardConferenceUnconfirmedParticipants($ids: [ID!]) {
  events(ids: $ids) {
    eNumber
    unconfirmedParticipantConnection {
      edges {
        status
        invitationStatus
        roles
        otherRole
        node {
          id
          name
          description
          conferencesAttendedCount
          primaryAffiliation
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
    BoardConferenceUnconfirmedParticipantsQuery,
    BoardConferenceUnconfirmedParticipantsQueryVariables
  >;
export const ConferenceReadingsDocument = new TypedDocumentString(`
    query ConferenceReadings($ids: [ID!]) {
  events(ids: $ids) {
    sessionsConnection {
      edges {
        node {
          title
          readingsConnection {
            edges {
              node {
                citation
              }
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  ConferenceReadingsQuery,
  ConferenceReadingsQueryVariables
>;
export const MyConferenceInterestsDocument = new TypedDocumentString(`
    query MyConferenceInterests {
  myConferenceInterests {
    id
    eNumber
    title
  }
}
    `) as unknown as TypedDocumentString<
  MyConferenceInterestsQuery,
  MyConferenceInterestsQueryVariables
>;
export const AddConferenceInterestDocument = new TypedDocumentString(`
    mutation AddConferenceInterest($eNumber: String!) {
  addConferenceInterest(eNumber: $eNumber) {
    id
    eNumber
    title
  }
}
    `) as unknown as TypedDocumentString<
  AddConferenceInterestMutation,
  AddConferenceInterestMutationVariables
>;
export const RemoveConferenceInterestDocument = new TypedDocumentString(`
    mutation RemoveConferenceInterest($eNumber: String!) {
  removeConferenceInterest(eNumber: $eNumber) {
    success
    eNumber
  }
}
    `) as unknown as TypedDocumentString<
  RemoveConferenceInterestMutation,
  RemoveConferenceInterestMutationVariables
>;
export const UpcomingBoardMeetingsDocument = new TypedDocumentString(`
    query UpcomingBoardMeetings($limit: Int = 10) {
  upcomingBoardMeetings(limit: $limit) {
    id
    title
    startDate
    endDate
  }
}
    `) as unknown as TypedDocumentString<
  UpcomingBoardMeetingsQuery,
  UpcomingBoardMeetingsQueryVariables
>;
export const SubmitHonorariumDocument = new TypedDocumentString(`
    mutation SubmitHonorarium($conferenceId: String!, $documentId: String, $conferees: [SubmitHonorariumConfereeInput!]!) {
  submitHonorarium(
    conferenceId: $conferenceId
    documentId: $documentId
    conferees: $conferees
  ) {
    success
    message
  }
}
    `) as unknown as TypedDocumentString<
  SubmitHonorariumMutation,
  SubmitHonorariumMutationVariables
>;
export const HonorariumConferencesDocument = new TypedDocumentString(`
    query HonorariumConferences {
  honorariumConferences {
    id
    eNumber
    title
    shortTitle
    startDate
    endDate
    region
    directorDisplay
    representative {
      name
    }
    venue {
      address {
        city
        stateProvinceRegion
        country
      }
    }
    honorarium {
      incompletePaymentCount
    }
  }
}
    `) as unknown as TypedDocumentString<
  HonorariumConferencesQuery,
  HonorariumConferencesQueryVariables
>;
export const HonorariumConferenceDetailsDocument = new TypedDocumentString(`
    query HonorariumConferenceDetails($eNumber: ID!) {
  events(ids: [$eNumber]) {
    id
    eNumber
    title
    shortTitle
    startDate
    endDate
    region
    directorDisplay
    representative {
      name
    }
    planner {
      name
    }
    venue {
      name
      address {
        city
        stateProvinceRegion
        country
      }
    }
    honorarium {
      incompletePaymentCount
      participantsConnection {
        edges {
          node {
            id
            name
          }
          roles
          otherRole
          status
          honorariaInfo {
            honorariaNotes
            payments {
              id
              programName
              fee
              taxWithholdingPercentage
              paymentDeclined
              paymentStatus
              participantType
              paymentNote
            }
          }
          accountInfo {
            intacctVendorId
            paymentEligible
            workVisa
            governmentPosition
            government
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  HonorariumConferenceDetailsQuery,
  HonorariumConferenceDetailsQueryVariables
>;
export const UpdateHonorariumNotesDocument = new TypedDocumentString(`
    mutation UpdateHonorariumNotes($eNumber: String!, $notes: [ConfereeNoteInput!]!) {
  updateHonorariumNotes(eNumber: $eNumber, notes: $notes) {
    success
  }
}
    `) as unknown as TypedDocumentString<
  UpdateHonorariumNotesMutation,
  UpdateHonorariumNotesMutationVariables
>;
export const LibertyAiConversationsDocument = new TypedDocumentString(`
    query LibertyAIConversations($ids: [ID!]) {
  libertyAIConversations(ids: $ids) {
    id
    createdAt
    updatedAt
    state
    statusMessage
    name
    lastReadAt
    messagesConnection {
      edges {
        cursor
        node {
          id
          conversationId
          role
          text
          blocks
          timestamp
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  LibertyAiConversationsQuery,
  LibertyAiConversationsQueryVariables
>;
export const LibertyAiConversationSummariesDocument = new TypedDocumentString(`
    query LibertyAIConversationSummaries {
  libertyAIConversations {
    id
    createdAt
    updatedAt
    state
    statusMessage
    name
  }
}
    `) as unknown as TypedDocumentString<
  LibertyAiConversationSummariesQuery,
  LibertyAiConversationSummariesQueryVariables
>;
export const SendLibertyAiMessageDocument = new TypedDocumentString(`
    mutation SendLibertyAIMessage($message: String!, $conversationId: ID) {
  sendLibertyAIMessage(message: $message, conversationId: $conversationId) {
    conversationId
  }
}
    `) as unknown as TypedDocumentString<
  SendLibertyAiMessageMutation,
  SendLibertyAiMessageMutationVariables
>;
export const DeleteLibertyAiConversationDocument = new TypedDocumentString(`
    mutation DeleteLibertyAIConversation($id: ID!) {
  deleteLibertyAIConversation(id: $id)
}
    `) as unknown as TypedDocumentString<
  DeleteLibertyAiConversationMutation,
  DeleteLibertyAiConversationMutationVariables
>;
export const RenameLibertyAiConversationDocument = new TypedDocumentString(`
    mutation RenameLibertyAIConversation($id: ID!, $name: String!) {
  renameLibertyAIConversation(id: $id, name: $name) {
    id
    name
  }
}
    `) as unknown as TypedDocumentString<
  RenameLibertyAiConversationMutation,
  RenameLibertyAiConversationMutationVariables
>;
export const SetLibertyAiConversationReadStateDocument =
  new TypedDocumentString(`
    mutation SetLibertyAIConversationReadState($id: ID!, $read: Boolean!) {
  setLibertyAIConversationReadState(id: $id, read: $read) {
    id
    lastReadAt
  }
}
    `) as unknown as TypedDocumentString<
    SetLibertyAiConversationReadStateMutation,
    SetLibertyAiConversationReadStateMutationVariables
  >;
export const OnLibertyAiNotificationDocument = new TypedDocumentString(`
    subscription OnLibertyAINotification($userId: ID!) {
  onLibertyAINotification(userId: $userId) {
    userId
    conversationId
    state
    statusMessage
    timestamp
  }
}
    `) as unknown as TypedDocumentString<
  OnLibertyAiNotificationSubscription,
  OnLibertyAiNotificationSubscriptionVariables
>;
export const LibertyAiMeDocument = new TypedDocumentString(`
    query LibertyAIMe {
  me {
    id
  }
}
    `) as unknown as TypedDocumentString<
  LibertyAiMeQuery,
  LibertyAiMeQueryVariables
>;
export const PendingObservationApprovalsDocument = new TypedDocumentString(`
    query PendingObservationApprovals($eNumber: String) {
  pendingObservationApprovals(eNumber: $eNumber) {
    id
    conferenceId
    summary
    location
    startDate
    endDate
    requestorName
    requestorEmail
  }
}
    `) as unknown as TypedDocumentString<
  PendingObservationApprovalsQuery,
  PendingObservationApprovalsQueryVariables
>;
export const ApprovedObservationsDocument = new TypedDocumentString(`
    query ApprovedObservations($requestorEmail: String!) {
  approvedObservations(requestorEmail: $requestorEmail) {
    id
    conferenceId
    summary
    location
    startDate
    endDate
    requestorName
    requestorEmail
  }
}
    `) as unknown as TypedDocumentString<
  ApprovedObservationsQuery,
  ApprovedObservationsQueryVariables
>;
export const CreateObservationRequestDocument = new TypedDocumentString(`
    mutation CreateObservationRequest($input: CreateObservationInput!) {
  createObservationRequest(input: $input) {
    id
    conferenceId
    summary
  }
}
    `) as unknown as TypedDocumentString<
  CreateObservationRequestMutation,
  CreateObservationRequestMutationVariables
>;
export const ApproveObservationsDocument = new TypedDocumentString(`
    mutation ApproveObservations($issueKeys: [String!]!) {
  approveObservations(issueKeys: $issueKeys) {
    results {
      issueKey
      success
      message
    }
  }
}
    `) as unknown as TypedDocumentString<
  ApproveObservationsMutation,
  ApproveObservationsMutationVariables
>;
export const PersonDetailsDocument = new TypedDocumentString(`
    query PersonDetails($ids: [ID!]!) {
  people(ids: $ids) {
    id
    name
    title
    description
    primaryAffiliation
    primaryExpertise
    personType
    imageUrl
    correspondenceEmail
    phone
    websiteUrl
    mailingStreet
    mailingCity
    mailingState
    mailingPostalCode
    mailingCountry
    mostRecentAttendedDate
    attendedConferencesOnlyCount
    attendedAsDirectorCount
    attendedAsDiscussionLeadCount
    strategicCategories {
      fiscalYear
      category
      tier
    }
    eventsConnection(eventStatuses: [PENDING, SCHEDULED, COMPLETED]) {
      edges {
        roles
        otherRole
        status
        invitationStatus
        node {
          eNumber
          title
          startDate
          endDate
          region
          status
          venue {
            address {
              city
              stateProvinceRegion
              country
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  PersonDetailsQuery,
  PersonDetailsQueryVariables
>;
export const CreateReferralDocument = new TypedDocumentString(`
    mutation CreateReferral($input: CreateReferralInput!) {
  createReferral(input: $input) {
    name
    affiliation
    reason
    expertise
    origin
    isPersonalContact
    willContact
  }
}
    `) as unknown as TypedDocumentString<
  CreateReferralMutation,
  CreateReferralMutationVariables
>;
export const SearchDocument = new TypedDocumentString(`
    query Search($term: String!) {
  search(term: $term) {
    people {
      id
      name
      correspondenceEmail
      phone
      imageUrl
      primaryAffiliation
    }
    events {
      eNumber
      title
      startDate
      endDate
      directorDisplay
      representative {
        name
      }
      region
      venue {
        address {
          city
          stateProvinceRegion
          country
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SearchQuery, SearchQueryVariables>;
export const TaxUpcomingConferencesDocument = new TypedDocumentString(`
    query TaxUpcomingConferences {
  taxUpcomingConferences {
    id
    eNumber
    title
    shortTitle
    startDate
    endDate
    region
    status
    directorDisplay
    representative {
      name
    }
    planner {
      name
    }
    venue {
      address {
        city
        stateProvinceRegion
        country
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  TaxUpcomingConferencesQuery,
  TaxUpcomingConferencesQueryVariables
>;
export const TaxUpcomingConferenceParticipantsDocument =
  new TypedDocumentString(`
    query TaxUpcomingConferenceParticipants {
  taxUpcomingConferences {
    id
    eNumber
    taxVendorPaymentMethods {
      vendorId
      paymentMethod
    }
    participantConnection(types: [TAX]) {
      edges {
        node {
          id
          name
          firstName
          lastName
          email
          assistantName
          assistantEmail
        }
        roles
        otherRole
        status
        taxInfo {
          needsTaxAuditAttention
          modifiedFields
          allPayments {
            id
            fee
            taxWithholdingPercentage
            paymentDeclined
            paymentNote
            participantType
          }
        }
        accountInfo {
          intacctVendorId
          paymentEligible
          workVisa
          governmentPosition
          government
          ssnItin
          financeAppNotes
          usGovPosition
          usCitizen
          paymentEligibleUpdatedDate
          w8DocumentUrl
          w8ValidUntil
          w9DocumentUrl
          w9Status
          x8233DocumentUrl
          x8233ValidUntil
        }
        governmentForm {
          citizenshipResidence
          countryOfResidenceTaxPurpose
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
    TaxUpcomingConferenceParticipantsQuery,
    TaxUpcomingConferenceParticipantsQueryVariables
  >;
export const ConferenceRegistrationDocument = new TypedDocumentString(`
    query ConferenceRegistration($eNumber: ID!) {
  events(ids: [$eNumber]) {
    id
    eNumber
    title
    startDate
    endDate
    participantConnection(types: [TAX]) {
      edges {
        node {
          id
          name
          firstName
          middleName
          lastName
          email
          phone
          phoneType
          mailingStreet
          mailingCity
          mailingState
          mailingPostalCode
          mailingCountry
          primaryAffiliation
          primaryAffiliationTitle
        }
        roles
        otherRole
        status
        invitationStatus
        taxInfo {
          modifiedFields
        }
        accountInfo {
          workVisa
          governmentPosition
          government
          ssnItin
          usCitizen
          usGovPosition
          financeAppNotes
        }
        governmentForm {
          positionHeld
          electiveOfficeUS
          presidentialAppointment
          publicOfficeAboveOrEq20k
          congressEmployeeAboveOrEq15k
          armedForcesPosition
          militaryAcademyProfessor
          scheduleCPosition
          compensationAboveThreshold
          assistantToOfficials
          irsOversightMember
          specialGovEmployee
          citizenshipResidence
          countryOfResidenceTaxPurpose
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<
  ConferenceRegistrationQuery,
  ConferenceRegistrationQueryVariables
>;
export const UpdateConfereeTaxDetailsDocument = new TypedDocumentString(`
    mutation UpdateConfereeTaxDetails($input: UpdateConfereeTaxDetailsInput!) {
  updateConfereeTaxDetails(input: $input) {
    success
    message
  }
}
    `) as unknown as TypedDocumentString<
  UpdateConfereeTaxDetailsMutation,
  UpdateConfereeTaxDetailsMutationVariables
>;
export const UpdateConfereeNeedsAttentionDocument = new TypedDocumentString(`
    mutation UpdateConfereeNeedsAttention($eNumber: String!, $guid: String!, $needsAttention: Boolean!) {
  updateConfereeNeedsAttention(
    eNumber: $eNumber
    guid: $guid
    needsAttention: $needsAttention
  ) {
    success
  }
}
    `) as unknown as TypedDocumentString<
  UpdateConfereeNeedsAttentionMutation,
  UpdateConfereeNeedsAttentionMutationVariables
>;
export const UploadTaxDocumentDocument = new TypedDocumentString(`
    mutation UploadTaxDocument($input: UploadTaxDocumentInput!) {
  uploadTaxDocument(input: $input) {
    success
  }
}
    `) as unknown as TypedDocumentString<
  UploadTaxDocumentMutation,
  UploadTaxDocumentMutationVariables
>;
export const TaxFormUploadUrlDocument = new TypedDocumentString(`
    query TaxFormUploadUrl($guid: String!, $fileFormat: TaxDocumentFormat!) {
  taxFormUploadUrl(guid: $guid, fileFormat: $fileFormat) {
    url
    fields
    expiresAt
    maxSize
  }
}
    `) as unknown as TypedDocumentString<
  TaxFormUploadUrlQuery,
  TaxFormUploadUrlQueryVariables
>;
export const TaxFormDownloadUrlDocument = new TypedDocumentString(`
    query TaxFormDownloadUrl($guid: String!, $fileFormat: TaxDocumentFormat!) {
  taxFormDownloadUrl(guid: $guid, fileFormat: $fileFormat) {
    url
    expiresAt
  }
}
    `) as unknown as TypedDocumentString<
  TaxFormDownloadUrlQuery,
  TaxFormDownloadUrlQueryVariables
>;
export const DeleteTaxDocumentDocument = new TypedDocumentString(`
    mutation DeleteTaxDocument($guid: String!, $fileFormat: TaxDocumentFormat!) {
  deleteTaxDocument(guid: $guid, fileFormat: $fileFormat) {
    success
  }
}
    `) as unknown as TypedDocumentString<
  DeleteTaxDocumentMutation,
  DeleteTaxDocumentMutationVariables
>;
